import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** The `ID` scalar type represents a unique MongoDB identifier in collection. MongoDB by default use 12-byte ObjectId value (https://docs.mongodb.com/manual/reference/bson-types/#objectid). But MongoDB also may accepts string or integer as correct values for _id field. */
  MongoID: { input: string; output: string };
};

export type TCreateOneExamInput = {
  clinicalIndication?: InputMaybe<Scalars['String']['input']>;
  detectionResults?: InputMaybe<Array<InputMaybe<TExamDetectionResultsInput>>>;
  device: Scalars['String']['input'];
  examDate?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  findings?: InputMaybe<Array<InputMaybe<TExamFindingsInput>>>;
  histologicalResult?: InputMaybe<EnumExamHistologicalResult>;
  laboratoryResult?: InputMaybe<TExamLaboratoryResultInput>;
  media?: InputMaybe<TExamMediaInput>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patient: Scalars['MongoID']['input'];
  physician?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumExamPriority>;
  status?: InputMaybe<EnumExamStatus>;
  technology: EnumExamTechnology;
};

export type TCreateOneExamPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<TErrorInterface>;
  /** Created document */
  record?: Maybe<TExam>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type TCreateOnePatientInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<EnumPatientEthnicity>;
  firstName: Scalars['String']['input'];
  identificationNumber: Scalars['String']['input'];
  identificationType: EnumPatientIdentificationType;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<EnumPatientSex>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TCreateOnePatientPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<TErrorInterface>;
  /** Created document */
  record?: Maybe<TPatient>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type TEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<TPatientNodeTc>;
};

export enum EnumExamDetectionResultsDetectionsAnoscopyGeniusHistologicalResult {
  Cancer = 'cancer',
  Hsil = 'hsil',
  Lsil = 'lsil',
  NonDysplasticLesion = 'nonDysplasticLesion',
  Normal = 'normal',
}

export enum EnumExamDetectionResultsDetectionsClass {
  Adc = 'ADC',
  Benign = 'Benign',
  Hsil = 'HSIL',
  Lsil = 'LSIL',
  Lesion = 'Lesion',
  Malignant = 'Malignant',
  Mucinous = 'Mucinous',
  Net = 'NET',
  Nonmucinous = 'Nonmucinous',
  Other = 'Other',
}

export enum EnumExamDetectionResultsDetectionsSmartCystHistologicalResult {
  Mucinous = 'mucinous',
  MucinousIpmnMd = 'mucinousIpmnMd',
  MucinousIpmnMdHigh = 'mucinousIpmnMdHigh',
  MucinousIpmnMdLow = 'mucinousIpmnMdLow',
  MucinousIpmnSb = 'mucinousIpmnSb',
  MucinousIpmnSbHigh = 'mucinousIpmnSbHigh',
  MucinousIpmnSbLow = 'mucinousIpmnSbLow',
  MucinousMcn = 'mucinousMcn',
  NonMucinous = 'nonMucinous',
  NonMucinousNetCysticComponent = 'nonMucinousNetCysticComponent',
  NonMucinousPseudocyst = 'nonMucinousPseudocyst',
  NonMucinousSerousCystadenoma = 'nonMucinousSerousCystadenoma',
  NonMucinousSolidPseudopapillaryNeoplasm = 'nonMucinousSolidPseudopapillaryNeoplasm',
  NonMucinousWalledOffPancreaticNecrosis = 'nonMucinousWalledOffPancreaticNecrosis',
}

export enum EnumExamDetectionResultsDetectionsSmartPancreasHistologicalResult {
  AccessorySpleen = 'accessorySpleen',
  Adenocarcinoma = 'adenocarcinoma',
  Cholangiocarcinoma = 'cholangiocarcinoma',
  InflammatoryMass = 'inflammatoryMass',
  Metastasis = 'metastasis',
  NeuroendocrineTumor = 'neuroendocrineTumor',
  Plasmacytoma = 'plasmacytoma',
  PseudopapillarySolidLesion = 'pseudopapillarySolidLesion',
  StromalTumor = 'stromalTumor',
}

export enum EnumExamHistologicalResult {
  B = 'B',
  M = 'M',
}

export enum EnumExamPriority {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
}

export enum EnumExamStatus {
  AnalysisError = 'analysis_error',
  Deleted = 'deleted',
  Draft = 'draft',
  FindingsLimitExceeded = 'findings_limit_exceeded',
  ReadyToValidate = 'ready_to_validate',
  UnderAnalysis = 'under_analysis',
  UploadError = 'upload_error',
  Validated = 'validated',
}

export enum EnumExamTechnology {
  AnoscopyGenius = 'anoscopyGenius',
  DeepCapsule = 'deepCapsule',
  IbdSmart = 'ibdSmart',
  SmartCholangio = 'smartCholangio',
  SmartCyst = 'smartCyst',
  SmartPancreas = 'smartPancreas',
}

export enum EnumInstitutionDataAccessScope {
  Institution = 'institution',
  User = 'user',
}

export enum EnumNotificationTechnology {
  AnoscopyGenius = 'anoscopyGenius',
  DeepCapsule = 'deepCapsule',
  IbdSmart = 'ibdSmart',
  SmartCholangio = 'smartCholangio',
  SmartCyst = 'smartCyst',
  SmartPancreas = 'smartPancreas',
}

export enum EnumNotificationType {
  EmptyString = 'EMPTY_STRING',
  Exam = 'exam',
  ExamAnalysisError = 'exam_analysis_error',
  ExamReportReady = 'exam_report_ready',
  ExamUploadError = 'exam_upload_error',
  FindingsLimitExceeded = 'findings_limit_exceeded',
  ReadyToValidate = 'ready_to_validate',
}

export enum EnumPatientEthnicity {
  AmericanIndianOrAlaskaNative = 'americanIndianOrAlaskaNative',
  Asian = 'asian',
  BlackOrAfricanAmerican = 'blackOrAfricanAmerican',
  HispanicOrLatino = 'hispanicOrLatino',
  MiddleEasternOrNorthAfrican = 'middleEasternOrNorthAfrican',
  NativeHawaiianOrPacificIslander = 'nativeHawaiianOrPacificIslander',
  White = 'white',
}

export enum EnumPatientIdentificationType {
  Health = 'health',
  Passport = 'passport',
  Ssn = 'ssn',
  Tax = 'tax',
}

export enum EnumPatientSex {
  Female = 'female',
  Male = 'male',
  Other = 'other',
}

export enum EnumPatientStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum EnumReducedExamHistologicalResult {
  B = 'B',
  M = 'M',
}

export enum EnumReducedExamPatientIdentificationType {
  Health = 'health',
  Passport = 'passport',
  Ssn = 'ssn',
  Tax = 'tax',
}

export enum EnumReducedExamPriority {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
}

export enum EnumReducedExamStatus {
  AnalysisError = 'analysis_error',
  Deleted = 'deleted',
  Draft = 'draft',
  FindingsLimitExceeded = 'findings_limit_exceeded',
  ReadyToValidate = 'ready_to_validate',
  UnderAnalysis = 'under_analysis',
  UploadError = 'upload_error',
  Validated = 'validated',
}

export enum EnumReducedExamTechnology {
  AnoscopyGenius = 'anoscopyGenius',
  DeepCapsule = 'deepCapsule',
  IbdSmart = 'ibdSmart',
  SmartCholangio = 'smartCholangio',
  SmartCyst = 'smartCyst',
  SmartPancreas = 'smartPancreas',
}

export type TErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type TExam = {
  _id: Scalars['MongoID']['output'];
  clinicalIndication?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  detectionResults?: Maybe<Array<Maybe<TExamDetectionResults>>>;
  device: Scalars['String']['output'];
  examDate?: Maybe<Scalars['Date']['output']>;
  filters?: Maybe<Scalars['JSON']['output']>;
  findings?: Maybe<Array<Maybe<TExamFindings>>>;
  histologicalResult?: Maybe<EnumExamHistologicalResult>;
  institution: Scalars['MongoID']['output'];
  laboratoryResult?: Maybe<TExamLaboratoryResult>;
  media?: Maybe<TExamMedia>;
  medicalNotes?: Maybe<Array<Maybe<TMedicalNote>>>;
  models?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  patient?: Maybe<TPatient>;
  physician?: Maybe<TUser>;
  priority?: Maybe<EnumExamPriority>;
  status?: Maybe<EnumExamStatus>;
  technology: EnumExamTechnology;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<TUser>;
};

export type TExamCountByTechnology = {
  count: Scalars['Int']['output'];
  technology: Scalars['String']['output'];
};

export type TExamDetectionResults = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  detections?: Maybe<Array<Maybe<TExamDetectionResultsDetections>>>;
  names: Scalars['JSON']['output'];
  origFilename: Scalars['String']['output'];
  origShape: Array<Maybe<Scalars['Float']['output']>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TExamDetectionResultsDetections = {
  anoscopyGeniusHistologicalResult?: Maybe<EnumExamDetectionResultsDetectionsAnoscopyGeniusHistologicalResult>;
  box: TExamDetectionResultsDetectionsBox;
  class: EnumExamDetectionResultsDetectionsClass;
  classId: Scalars['Float']['output'];
  confidence: Scalars['Float']['output'];
  position?: Maybe<Scalars['Float']['output']>;
  smartCystHistologicalResult?: Maybe<EnumExamDetectionResultsDetectionsSmartCystHistologicalResult>;
  smartPancreasHistologicalResult?: Maybe<EnumExamDetectionResultsDetectionsSmartPancreasHistologicalResult>;
};

export type TExamDetectionResultsDetectionsBox = {
  bottom: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  right: Scalars['Float']['output'];
  top: Scalars['Float']['output'];
};

export type TExamDetectionResultsDetectionsBoxInput = {
  bottom: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  right: Scalars['Float']['input'];
  top: Scalars['Float']['input'];
};

export type TExamDetectionResultsDetectionsInput = {
  anoscopyGeniusHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsAnoscopyGeniusHistologicalResult>;
  box: TExamDetectionResultsDetectionsBoxInput;
  class: EnumExamDetectionResultsDetectionsClass;
  classId: Scalars['Float']['input'];
  confidence: Scalars['Float']['input'];
  position?: InputMaybe<Scalars['Float']['input']>;
  smartCystHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsSmartCystHistologicalResult>;
  smartPancreasHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsSmartPancreasHistologicalResult>;
};

export type TExamDetectionResultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  detections?: InputMaybe<
    Array<InputMaybe<TExamDetectionResultsDetectionsInput>>
  >;
  names: Scalars['JSON']['input'];
  origFilename: Scalars['String']['input'];
  origShape: Array<InputMaybe<Scalars['Float']['input']>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TExamFindings = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  frame: Scalars['String']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  index: Scalars['Float']['output'];
  location?: Maybe<Scalars['String']['output']>;
  relevant?: Maybe<Scalars['Boolean']['output']>;
  targets?: Maybe<Array<Maybe<TExamFindingsTargets>>>;
  thumbnail: Scalars['String']['output'];
  timeStamp?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userLabel?: Maybe<Scalars['String']['output']>;
};

export type TExamFindingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  frame: Scalars['String']['input'];
  highlight?: InputMaybe<Scalars['Boolean']['input']>;
  index: Scalars['Float']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  relevant?: InputMaybe<Scalars['Boolean']['input']>;
  targets?: InputMaybe<Array<InputMaybe<TExamFindingsTargetsInput>>>;
  thumbnail: Scalars['String']['input'];
  timeStamp?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userLabel?: InputMaybe<Scalars['String']['input']>;
};

export type TExamFindingsTargets = {
  _id?: Maybe<Scalars['MongoID']['output']>;
  certainty: Scalars['Float']['output'];
  code: Scalars['String']['output'];
};

export type TExamFindingsTargetsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  certainty: Scalars['Float']['input'];
  code: Scalars['String']['input'];
};

export type TExamLaboratoryResult = {
  ceaLevel?: Maybe<Scalars['Float']['output']>;
  glucoseLevel?: Maybe<Scalars['Float']['output']>;
};

export type TExamLaboratoryResultInput = {
  ceaLevel?: InputMaybe<Scalars['Float']['input']>;
  glucoseLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type TExamMedia = {
  frames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fullVideo?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Scalars['String']['output']>;
};

export type TExamMediaInput = {
  frames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullVideo?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Scalars['String']['input']>;
};

export type TExamsByUserConnection = {
  edges: Array<TReducedExamEdgeTc>;
  pageInfo: TPageInfo;
};

export type TFilterCountExamDetectionResultsDetectionsBoxInput = {
  bottom?: InputMaybe<Scalars['Float']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  right?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
};

export type TFilterCountExamDetectionResultsDetectionsInput = {
  anoscopyGeniusHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsAnoscopyGeniusHistologicalResult>;
  box?: InputMaybe<TFilterCountExamDetectionResultsDetectionsBoxInput>;
  class?: InputMaybe<EnumExamDetectionResultsDetectionsClass>;
  classId?: InputMaybe<Scalars['Float']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  smartCystHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsSmartCystHistologicalResult>;
  smartPancreasHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsSmartPancreasHistologicalResult>;
};

export type TFilterCountExamDetectionResultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  detections?: InputMaybe<
    Array<InputMaybe<TFilterCountExamDetectionResultsDetectionsInput>>
  >;
  names?: InputMaybe<Scalars['JSON']['input']>;
  origFilename?: InputMaybe<Scalars['String']['input']>;
  origShape?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TFilterCountExamFindingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  frame?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  relevant?: InputMaybe<Scalars['Boolean']['input']>;
  targets?: InputMaybe<Array<InputMaybe<TFilterCountExamFindingsTargetsInput>>>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  timeStamp?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userLabel?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterCountExamFindingsTargetsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  certainty?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterCountExamInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  clinicalIndication?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  detectionResults?: InputMaybe<
    Array<InputMaybe<TFilterCountExamDetectionResultsInput>>
  >;
  device?: InputMaybe<Scalars['String']['input']>;
  examDate?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  findings?: InputMaybe<Array<InputMaybe<TFilterCountExamFindingsInput>>>;
  histologicalResult?: InputMaybe<EnumExamHistologicalResult>;
  laboratoryResult?: InputMaybe<TFilterCountExamLaboratoryResultInput>;
  media?: InputMaybe<TFilterCountExamMediaInput>;
  medicalNotes?: InputMaybe<Array<InputMaybe<TFilterCountMedicalNoteInput>>>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patient?: InputMaybe<Scalars['MongoID']['input']>;
  physician?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumExamPriority>;
  status?: InputMaybe<EnumExamStatus>;
  technology?: InputMaybe<EnumExamTechnology>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type TFilterCountExamLaboratoryResultInput = {
  ceaLevel?: InputMaybe<Scalars['Float']['input']>;
  glucoseLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type TFilterCountExamMediaInput = {
  frames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullVideo?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterCountMedicalNoteInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['Date']['input']>;
  updateDate?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type TFilterCountUserInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  biography?: InputMaybe<Scalars['String']['input']>;
  cloudflareId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCallingCode?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterFindManyExamDetectionResultsDetectionsBoxInput = {
  bottom?: InputMaybe<Scalars['Float']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  right?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
};

export type TFilterFindManyExamDetectionResultsDetectionsInput = {
  anoscopyGeniusHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsAnoscopyGeniusHistologicalResult>;
  box?: InputMaybe<TFilterFindManyExamDetectionResultsDetectionsBoxInput>;
  class?: InputMaybe<EnumExamDetectionResultsDetectionsClass>;
  classId?: InputMaybe<Scalars['Float']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  smartCystHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsSmartCystHistologicalResult>;
  smartPancreasHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsSmartPancreasHistologicalResult>;
};

export type TFilterFindManyExamDetectionResultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  detections?: InputMaybe<
    Array<InputMaybe<TFilterFindManyExamDetectionResultsDetectionsInput>>
  >;
  names?: InputMaybe<Scalars['JSON']['input']>;
  origFilename?: InputMaybe<Scalars['String']['input']>;
  origShape?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TFilterFindManyExamFindingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  frame?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  relevant?: InputMaybe<Scalars['Boolean']['input']>;
  targets?: InputMaybe<
    Array<InputMaybe<TFilterFindManyExamFindingsTargetsInput>>
  >;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  timeStamp?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userLabel?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterFindManyExamFindingsTargetsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  certainty?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterFindManyExamInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  clinicalIndication?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  detectionResults?: InputMaybe<
    Array<InputMaybe<TFilterFindManyExamDetectionResultsInput>>
  >;
  device?: InputMaybe<Scalars['String']['input']>;
  examDate?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  findings?: InputMaybe<Array<InputMaybe<TFilterFindManyExamFindingsInput>>>;
  histologicalResult?: InputMaybe<EnumExamHistologicalResult>;
  laboratoryResult?: InputMaybe<TFilterFindManyExamLaboratoryResultInput>;
  media?: InputMaybe<TFilterFindManyExamMediaInput>;
  medicalNotes?: InputMaybe<Array<InputMaybe<TFilterFindManyMedicalNoteInput>>>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patient?: InputMaybe<Scalars['MongoID']['input']>;
  physician?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumExamPriority>;
  status?: InputMaybe<EnumExamStatus>;
  technology: EnumExamTechnology;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type TFilterFindManyExamLaboratoryResultInput = {
  ceaLevel?: InputMaybe<Scalars['Float']['input']>;
  glucoseLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type TFilterFindManyExamMediaInput = {
  frames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullVideo?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterFindManyMedicalNoteInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['Date']['input']>;
  updateDate?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type TFilterFindManyNotificationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  examId?: InputMaybe<Scalars['MongoID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  technology?: InputMaybe<EnumNotificationTechnology>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumNotificationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TFilterFindManyReducedExamInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  detectionsCount?: InputMaybe<Scalars['Float']['input']>;
  examDate?: InputMaybe<Scalars['Date']['input']>;
  histologicalResult?: InputMaybe<EnumReducedExamHistologicalResult>;
  patient?: InputMaybe<TFilterFindManyReducedExamPatientInput>;
  priority?: InputMaybe<EnumReducedExamPriority>;
  relevantFindingsCount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EnumReducedExamStatus>;
  technology: EnumReducedExamTechnology;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<TFilterFindManyReducedExamUserInput>;
};

export type TFilterFindManyReducedExamPatientInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<EnumReducedExamPatientIdentificationType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterFindManyReducedExamUserInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterFindManyUserInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  biography?: InputMaybe<Scalars['String']['input']>;
  cloudflareId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCallingCode?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterFindOneExamDetectionResultsDetectionsBoxInput = {
  bottom?: InputMaybe<Scalars['Float']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  right?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
};

export type TFilterFindOneExamDetectionResultsDetectionsInput = {
  anoscopyGeniusHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsAnoscopyGeniusHistologicalResult>;
  box?: InputMaybe<TFilterFindOneExamDetectionResultsDetectionsBoxInput>;
  class?: InputMaybe<EnumExamDetectionResultsDetectionsClass>;
  classId?: InputMaybe<Scalars['Float']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  smartCystHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsSmartCystHistologicalResult>;
  smartPancreasHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsSmartPancreasHistologicalResult>;
};

export type TFilterFindOneExamDetectionResultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  detections?: InputMaybe<
    Array<InputMaybe<TFilterFindOneExamDetectionResultsDetectionsInput>>
  >;
  names?: InputMaybe<Scalars['JSON']['input']>;
  origFilename?: InputMaybe<Scalars['String']['input']>;
  origShape?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TFilterFindOneExamFindingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  frame?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  relevant?: InputMaybe<Scalars['Boolean']['input']>;
  targets?: InputMaybe<
    Array<InputMaybe<TFilterFindOneExamFindingsTargetsInput>>
  >;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  timeStamp?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userLabel?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterFindOneExamFindingsTargetsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  certainty?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterFindOneExamInput = {
  _id: Scalars['MongoID']['input'];
  clinicalIndication?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  detectionResults?: InputMaybe<
    Array<InputMaybe<TFilterFindOneExamDetectionResultsInput>>
  >;
  device?: InputMaybe<Scalars['String']['input']>;
  examDate?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  findings?: InputMaybe<Array<InputMaybe<TFilterFindOneExamFindingsInput>>>;
  histologicalResult?: InputMaybe<EnumExamHistologicalResult>;
  laboratoryResult?: InputMaybe<TFilterFindOneExamLaboratoryResultInput>;
  media?: InputMaybe<TFilterFindOneExamMediaInput>;
  medicalNotes?: InputMaybe<Array<InputMaybe<TFilterFindOneMedicalNoteInput>>>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patient?: InputMaybe<Scalars['MongoID']['input']>;
  physician?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumExamPriority>;
  status?: InputMaybe<EnumExamStatus>;
  technology?: InputMaybe<EnumExamTechnology>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type TFilterFindOneExamLaboratoryResultInput = {
  ceaLevel?: InputMaybe<Scalars['Float']['input']>;
  glucoseLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type TFilterFindOneExamMediaInput = {
  frames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullVideo?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterFindOneMedicalNoteInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['Date']['input']>;
  updateDate?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type TFilterFindOnePatientInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<EnumPatientEthnicity>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<EnumPatientIdentificationType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<EnumPatientSex>;
  status?: InputMaybe<EnumPatientStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type TFilterFindOneUserInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  biography?: InputMaybe<Scalars['String']['input']>;
  cloudflareId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCallingCode?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TFilterRemoveOneNotificationInput = {
  _id: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  examId?: InputMaybe<Scalars['MongoID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  technology?: InputMaybe<EnumNotificationTechnology>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumNotificationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TFilterUpdateOneNotificationInput = {
  _id: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  examId?: InputMaybe<Scalars['MongoID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  technology?: InputMaybe<EnumNotificationTechnology>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumNotificationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TFilterUpdateOnePatientInput = {
  _id: Scalars['MongoID']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<EnumPatientEthnicity>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<EnumPatientIdentificationType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<EnumPatientSex>;
  status?: InputMaybe<EnumPatientStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type TInputUpdatedFinding = {
  /** ID of the finding to be updated. */
  findingId: Scalars['MongoID']['input'];
  /** Indicates if the finding is relevant. If undefined, it will be updated to false. */
  relevant?: InputMaybe<Scalars['Boolean']['input']>;
  /** User-defined label for the finding. If undefined, it will not update the label. */
  userLabel?: InputMaybe<Scalars['String']['input']>;
};

export type TInstitution = {
  _id: Scalars['MongoID']['output'];
  dataAccessScope?: Maybe<EnumInstitutionDataAccessScope>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type TMedicalNote = {
  _id: Scalars['MongoID']['output'];
  content: Scalars['String']['output'];
  creationDate: Scalars['Date']['output'];
  updateDate?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<TUser>;
};

export type TMongoError = TErrorInterface & {
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type TMutation = {
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createExam?: Maybe<TCreateOneExamPayload>;
  createMedicalNote?: Maybe<TExam>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createPatient?: Maybe<TCreateOnePatientPayload>;
  deleteMedicalNote?: Maybe<TExam>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeExam?: Maybe<TRemoveByIdExamPayload>;
  removeExamNotifications?: Maybe<TRemoveExamNotificationsPayload>;
  /** Remove one document: 1) Remove with hooks via findOneAndRemove. 2) Return removed document. */
  removeNotification?: Maybe<TRemoveOneNotificationPayload>;
  removePatientById?: Maybe<Scalars['Boolean']['output']>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateExam?: Maybe<TUpdateByIdExamPayload>;
  updateExamDetectionHistologicalResult?: Maybe<TExam>;
  updateExamFindingHighlight?: Maybe<TExamFindings>;
  updateMedicalNote?: Maybe<TExam>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateNotification?: Maybe<TUpdateOneNotificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updatePatient?: Maybe<TUpdateOnePatientPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateUser?: Maybe<TUpdateByIdUserPayload>;
  validateExam?: Maybe<TExam>;
};

export type TMutationCreateExamArgs = {
  record: TCreateOneExamInput;
};

export type TMutationCreateMedicalNoteArgs = {
  content: Scalars['String']['input'];
  examId: Scalars['MongoID']['input'];
};

export type TMutationCreatePatientArgs = {
  record: TCreateOnePatientInput;
};

export type TMutationDeleteMedicalNoteArgs = {
  examId: Scalars['MongoID']['input'];
  id: Scalars['MongoID']['input'];
};

export type TMutationRemoveExamArgs = {
  _id: Scalars['MongoID']['input'];
};

export type TMutationRemoveExamNotificationsArgs = {
  examId: Scalars['MongoID']['input'];
  notificationType: EnumNotificationType;
};

export type TMutationRemoveNotificationArgs = {
  filter: TFilterRemoveOneNotificationInput;
  sort?: InputMaybe<SortRemoveOneNotificationInput>;
};

export type TMutationRemovePatientByIdArgs = {
  id: Scalars['MongoID']['input'];
};

export type TMutationUpdateExamArgs = {
  _id: Scalars['MongoID']['input'];
  record: TUpdateByIdExamInput;
};

export type TMutationUpdateExamDetectionHistologicalResultArgs = {
  _id: Scalars['MongoID']['input'];
  detectionResultId: Scalars['MongoID']['input'];
  histologicalResult?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  technology: EnumExamTechnology;
};

export type TMutationUpdateExamFindingHighlightArgs = {
  _id: Scalars['MongoID']['input'];
  findingHighlight: Scalars['Boolean']['input'];
  findingIndex: Scalars['Int']['input'];
};

export type TMutationUpdateMedicalNoteArgs = {
  content: Scalars['String']['input'];
  examId: Scalars['MongoID']['input'];
  id: Scalars['MongoID']['input'];
};

export type TMutationUpdateNotificationArgs = {
  filter: TFilterUpdateOneNotificationInput;
  record: TUpdateOneNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneNotificationInput>;
};

export type TMutationUpdatePatientArgs = {
  filter: TFilterUpdateOnePatientInput;
  record: TUpdateOnePatientInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePatientInput>;
};

export type TMutationUpdateUserArgs = {
  record: TUpdateByIdUserInput;
};

export type TMutationValidateExamArgs = {
  _id: Scalars['MongoID']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
  updatedFindings: Array<TInputUpdatedFinding>;
};

export type TNotification = {
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exam?: Maybe<TExam>;
  examId?: Maybe<Scalars['MongoID']['output']>;
  read: Scalars['Boolean']['output'];
  technology: EnumNotificationTechnology;
  title: Scalars['String']['output'];
  type?: Maybe<EnumNotificationType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['MongoID']['output']>;
};

export type TNotificationEdge = {
  cursor: Scalars['String']['output'];
  node?: Maybe<TNotification>;
};

export type TPageInfo = {
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type TPatient = {
  _id: Scalars['MongoID']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<EnumPatientEthnicity>;
  examCountByTechnology?: Maybe<Array<Maybe<TExamCountByTechnology>>>;
  firstName: Scalars['String']['output'];
  identificationNumber: Scalars['String']['output'];
  identificationType: EnumPatientIdentificationType;
  institutionId: Scalars['MongoID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<EnumPatientSex>;
  status?: Maybe<EnumPatientStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId: Scalars['MongoID']['output'];
};

export type TPatientListConnection = {
  edges?: Maybe<Array<Maybe<TEdge>>>;
  pageInfo?: Maybe<TPageInfo>;
};

export type TPatientNodeTc = {
  _id: Scalars['MongoID']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  firstName: Scalars['String']['output'];
  identificationNumber: Scalars['String']['output'];
  identificationType: EnumPatientIdentificationType;
  lastName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TPatientsReducedTc = {
  _id: Scalars['MongoID']['output'];
  fullIdentification?: Maybe<Scalars['String']['output']>;
};

export type TPatientsSearch = {
  hasMoreResults?: Maybe<Scalars['Boolean']['output']>;
  patients?: Maybe<Array<Maybe<TPatientsReducedTc>>>;
};

export type TQuery = {
  exam?: Maybe<TExam>;
  examCount?: Maybe<Scalars['Int']['output']>;
  exams: Array<TExam>;
  examsByPatient: Array<TReducedExam>;
  examsByUserConnection?: Maybe<TExamsByUserConnection>;
  patient?: Maybe<TPatient>;
  patientListConnection?: Maybe<TPatientListConnection>;
  patientsSearch?: Maybe<TPatientsSearch>;
  recentActivity: Array<TReducedExam>;
  user?: Maybe<TUser>;
  userCount?: Maybe<Scalars['Int']['output']>;
  userNotifications: Array<TNotification>;
  userNotificationsConnection?: Maybe<TUserNotificationsConnection>;
  userUnreadNotificationsCount: Scalars['Int']['output'];
  users: Array<TUser>;
};

export type TQueryExamArgs = {
  filter: TFilterFindOneExamInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneExamInput>;
};

export type TQueryExamCountArgs = {
  filter?: InputMaybe<TFilterCountExamInput>;
};

export type TQueryExamsArgs = {
  filter: TFilterFindManyExamInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyExamInput>;
};

export type TQueryExamsByPatientArgs = {
  filter: TFilterFindManyReducedExamInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyReducedExamInput>;
};

export type TQueryExamsByUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  afterDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  beforeDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  technology?: InputMaybe<EnumExamTechnology>;
};

export type TQueryPatientArgs = {
  filter?: InputMaybe<TFilterFindOnePatientInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePatientInput>;
};

export type TQueryPatientListConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type TQueryPatientsSearchArgs = {
  search: Scalars['String']['input'];
};

export type TQueryRecentActivityArgs = {
  filter: TFilterFindManyReducedExamInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyReducedExamInput>;
};

export type TQueryUserArgs = {
  filter?: InputMaybe<TFilterFindOneUserInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type TQueryUserCountArgs = {
  filter?: InputMaybe<TFilterCountUserInput>;
};

export type TQueryUserNotificationsArgs = {
  filter?: InputMaybe<TFilterFindManyNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationInput>;
};

export type TQueryUserNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  technology: EnumNotificationTechnology;
};

export type TQueryUserUnreadNotificationsCountArgs = {
  technology: EnumNotificationTechnology;
};

export type TQueryUsersArgs = {
  filter?: InputMaybe<TFilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};

export type TReducedExam = {
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  detectionsCount: Scalars['Float']['output'];
  examDate?: Maybe<Scalars['Date']['output']>;
  histologicalResult?: Maybe<EnumReducedExamHistologicalResult>;
  institution?: Maybe<Scalars['MongoID']['output']>;
  patient?: Maybe<TReducedExamPatient>;
  priority?: Maybe<EnumReducedExamPriority>;
  relevantFindingsCount: Scalars['Float']['output'];
  status: EnumReducedExamStatus;
  technology: EnumReducedExamTechnology;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<TReducedExamUser>;
};

export type TReducedExamEdgeTc = {
  cursor: Scalars['String']['output'];
  node: TReducedExam;
};

export type TReducedExamPatient = {
  _id: Scalars['MongoID']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  identificationNumber: Scalars['String']['output'];
  identificationType: EnumReducedExamPatientIdentificationType;
  lastName: Scalars['String']['output'];
};

export type TReducedExamUser = {
  _id: Scalars['MongoID']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type TRemoveByIdExamPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<TErrorInterface>;
  /** Removed document */
  record?: Maybe<TExam>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type TRemoveExamNotificationsPayload = {
  deletedCount: Scalars['Int']['output'];
};

export type TRemoveOneNotificationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<TErrorInterface>;
  /** Removed document */
  record?: Maybe<TNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type TRuntimeError = TErrorInterface & {
  /** Runtime error message */
  message?: Maybe<Scalars['String']['output']>;
};

export enum SortFindManyExamInput {
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyNotificationInput {
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyReducedExamInput {
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  RecentActivity = 'recentActivity',
}

export enum SortFindManyUserInput {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  NameAsc = 'NAME_ASC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneExamInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePatientInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  FirstnameLastnameAsc = 'FIRSTNAME__LASTNAME_ASC',
  FirstnameLastnameDesc = 'FIRSTNAME__LASTNAME_DESC',
  FirstnameLastnameIdentificationnumberAsc = 'FIRSTNAME__LASTNAME__IDENTIFICATIONNUMBER_ASC',
  FirstnameLastnameIdentificationnumberDesc = 'FIRSTNAME__LASTNAME__IDENTIFICATIONNUMBER_DESC',
  IdentificationtypeAsc = 'IDENTIFICATIONTYPE_ASC',
  IdentificationtypeDesc = 'IDENTIFICATIONTYPE_DESC',
  IdentificationtypeIdentificationnumberAsc = 'IDENTIFICATIONTYPE__IDENTIFICATIONNUMBER_ASC',
  IdentificationtypeIdentificationnumberDesc = 'IDENTIFICATIONTYPE__IDENTIFICATIONNUMBER_DESC',
  IdentificationtypeIdentificationnumberUseridAsc = 'IDENTIFICATIONTYPE__IDENTIFICATIONNUMBER__USERID_ASC',
  IdentificationtypeIdentificationnumberUseridDesc = 'IDENTIFICATIONTYPE__IDENTIFICATIONNUMBER__USERID_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneUserInput {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortRemoveOneNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortUpdateOneNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortUpdateOnePatientInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  FirstnameLastnameAsc = 'FIRSTNAME__LASTNAME_ASC',
  FirstnameLastnameDesc = 'FIRSTNAME__LASTNAME_DESC',
  FirstnameLastnameIdentificationnumberAsc = 'FIRSTNAME__LASTNAME__IDENTIFICATIONNUMBER_ASC',
  FirstnameLastnameIdentificationnumberDesc = 'FIRSTNAME__LASTNAME__IDENTIFICATIONNUMBER_DESC',
  IdentificationtypeAsc = 'IDENTIFICATIONTYPE_ASC',
  IdentificationtypeDesc = 'IDENTIFICATIONTYPE_DESC',
  IdentificationtypeIdentificationnumberAsc = 'IDENTIFICATIONTYPE__IDENTIFICATIONNUMBER_ASC',
  IdentificationtypeIdentificationnumberDesc = 'IDENTIFICATIONTYPE__IDENTIFICATIONNUMBER_DESC',
  IdentificationtypeIdentificationnumberUseridAsc = 'IDENTIFICATIONTYPE__IDENTIFICATIONNUMBER__USERID_ASC',
  IdentificationtypeIdentificationnumberUseridDesc = 'IDENTIFICATIONTYPE__IDENTIFICATIONNUMBER__USERID_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export type TUpdateByIdExamDetectionResultsDetectionsBoxInput = {
  bottom?: InputMaybe<Scalars['Float']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  right?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
};

export type TUpdateByIdExamDetectionResultsDetectionsInput = {
  anoscopyGeniusHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsAnoscopyGeniusHistologicalResult>;
  box?: InputMaybe<TUpdateByIdExamDetectionResultsDetectionsBoxInput>;
  class?: InputMaybe<EnumExamDetectionResultsDetectionsClass>;
  classId?: InputMaybe<Scalars['Float']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  smartCystHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsSmartCystHistologicalResult>;
  smartPancreasHistologicalResult?: InputMaybe<EnumExamDetectionResultsDetectionsSmartPancreasHistologicalResult>;
};

export type TUpdateByIdExamDetectionResultsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  detections?: InputMaybe<
    Array<InputMaybe<TUpdateByIdExamDetectionResultsDetectionsInput>>
  >;
  names?: InputMaybe<Scalars['JSON']['input']>;
  origFilename?: InputMaybe<Scalars['String']['input']>;
  origShape?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TUpdateByIdExamFindingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  frame?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  relevant?: InputMaybe<Scalars['Boolean']['input']>;
  targets?: InputMaybe<Array<InputMaybe<TUpdateByIdExamFindingsTargetsInput>>>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  timeStamp?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userLabel?: InputMaybe<Scalars['String']['input']>;
};

export type TUpdateByIdExamFindingsTargetsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  certainty?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
};

export type TUpdateByIdExamInput = {
  clinicalIndication?: InputMaybe<Scalars['String']['input']>;
  detectionResults?: InputMaybe<
    Array<InputMaybe<TUpdateByIdExamDetectionResultsInput>>
  >;
  device?: InputMaybe<Scalars['String']['input']>;
  examDate?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  findings?: InputMaybe<Array<InputMaybe<TUpdateByIdExamFindingsInput>>>;
  histologicalResult?: InputMaybe<EnumExamHistologicalResult>;
  laboratoryResult?: InputMaybe<TUpdateByIdExamLaboratoryResultInput>;
  media?: InputMaybe<TUpdateByIdExamMediaInput>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physician?: InputMaybe<Scalars['MongoID']['input']>;
  priority?: InputMaybe<EnumExamPriority>;
  status?: InputMaybe<EnumExamStatus>;
  technology?: InputMaybe<EnumExamTechnology>;
};

export type TUpdateByIdExamLaboratoryResultInput = {
  ceaLevel?: InputMaybe<Scalars['Float']['input']>;
  glucoseLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type TUpdateByIdExamMediaInput = {
  frames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullVideo?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Scalars['String']['input']>;
};

export type TUpdateByIdExamPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<TErrorInterface>;
  /** Updated document */
  record?: Maybe<TExam>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type TUpdateByIdUserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  biography?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCallingCode?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
};

export type TUpdateByIdUserPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<TErrorInterface>;
  /** Updated document */
  record?: Maybe<TUser>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type TUpdateOneNotificationInput = {
  read?: InputMaybe<Scalars['Boolean']['input']>;
  technology?: InputMaybe<EnumNotificationTechnology>;
};

export type TUpdateOneNotificationPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<TErrorInterface>;
  /** Updated document */
  record?: Maybe<TNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type TUpdateOnePatientInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<EnumPatientEthnicity>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<EnumPatientIdentificationType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<EnumPatientSex>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TUpdateOnePatientPayload = {
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<TErrorInterface>;
  /** Updated document */
  record?: Maybe<TPatient>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type TUser = {
  _id: Scalars['MongoID']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  biography?: Maybe<Scalars['String']['output']>;
  cloudflareId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCallingCode?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  institution?: Maybe<TInstitution>;
  lastName: Scalars['String']['output'];
  license?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
};

export type TUserNotificationsConnection = {
  edges?: Maybe<Array<Maybe<TNotificationEdge>>>;
  pageInfo?: Maybe<TPageInfo>;
};

export type TValidationError = TErrorInterface & {
  /** List of validator errors */
  errors?: Maybe<Array<TValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']['output']>;
};

export type TValidatorError = {
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type TGetExamForResubmitQueryVariables = Exact<{
  examId: Scalars['MongoID']['input'];
}>;

export type TGetExamForResubmitQuery = {
  exam?:
    | {
        _id: string;
        filters?: any | undefined;
        user?:
          | { firebaseId: string; institution?: { _id: string } | undefined }
          | undefined;
      }
    | undefined;
};

export type TGetExamForReuploadQueryVariables = Exact<{
  examId: Scalars['MongoID']['input'];
}>;

export type TGetExamForReuploadQuery = {
  exam?:
    | {
        _id: string;
        technology: EnumExamTechnology;
        device: string;
        user?:
          | { firebaseId: string; institution?: { _id: string } | undefined }
          | undefined;
      }
    | undefined;
};

export type TUpdateExamMutationVariables = Exact<{
  updateExamId: Scalars['MongoID']['input'];
  updateExamRecord: TUpdateByIdExamInput;
}>;

export type TUpdateExamMutation = {
  updateExam?:
    | {
        record?:
          | {
              _id: string;
              technology: EnumExamTechnology;
              device: string;
              examDate?: string | undefined;
              clinicalIndication?: string | undefined;
              histologicalResult?: EnumExamHistologicalResult | undefined;
              status?: EnumExamStatus | undefined;
              filters?: any | undefined;
              priority?: EnumExamPriority | undefined;
              models?: Array<string | undefined> | undefined;
              laboratoryResult?:
                | {
                    glucoseLevel?: number | undefined;
                    ceaLevel?: number | undefined;
                  }
                | undefined;
              user?:
                | { _id: string; institution?: { _id: string } | undefined }
                | undefined;
              physician?: { _id: string } | undefined;
              media?:
                | {
                    fullVideo?: string | undefined;
                    highlights?: string | undefined;
                    frames?: Array<string | undefined> | undefined;
                  }
                | undefined;
              medicalNotes?:
                | Array<
                    | {
                        _id: string;
                        content: string;
                        user?:
                          | { _id: string; firstName: string; lastName: string }
                          | undefined;
                      }
                    | undefined
                  >
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type TGetExamStatusQueryVariables = Exact<{
  examId: Scalars['MongoID']['input'];
}>;

export type TGetExamStatusQuery = {
  exam?: { status?: EnumExamStatus | undefined } | undefined;
};

export type TGetUsersQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyUserInput>;
}>;

export type TGetUsersQuery = {
  users: Array<{
    _id: string;
    firstName: string;
    lastName: string;
    avatar?: string | undefined;
  }>;
};

export type TRemoveExamNotificationsMutationVariables = Exact<{
  examId: Scalars['MongoID']['input'];
  notificationType: EnumNotificationType;
}>;

export type TRemoveExamNotificationsMutation = {
  removeExamNotifications?: { deletedCount: number } | undefined;
};

export type TUpdateExamFindingHighlightMutationVariables = Exact<{
  updateExamId: Scalars['MongoID']['input'];
  updateFindingIndex: Scalars['Int']['input'];
  updateFindingHighlight: Scalars['Boolean']['input'];
}>;

export type TUpdateExamFindingHighlightMutation = {
  updateExamFindingHighlight?:
    | { _id?: string | undefined; highlight?: boolean | undefined }
    | undefined;
};

export type TNotificationFieldsFragment = {
  _id: string;
  userId?: string | undefined;
  title: string;
  description?: string | undefined;
  type?: EnumNotificationType | undefined;
  read: boolean;
  technology: EnumNotificationTechnology;
  exam?: { _id: string; patient?: { _id: string } | undefined } | undefined;
};

export type TGetUserNotificationsConnectionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  technology: EnumNotificationTechnology;
}>;

export type TGetUserNotificationsConnectionQuery = {
  userNotificationsConnection?:
    | {
        pageInfo?:
          | {
              hasNextPage?: boolean | undefined;
              endCursor?: string | undefined;
            }
          | undefined;
        edges?:
          | Array<
              | {
                  cursor: string;
                  node?:
                    | {
                        _id: string;
                        userId?: string | undefined;
                        title: string;
                        description?: string | undefined;
                        type?: EnumNotificationType | undefined;
                        read: boolean;
                        technology: EnumNotificationTechnology;
                        exam?:
                          | {
                              _id: string;
                              patient?: { _id: string } | undefined;
                            }
                          | undefined;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type TGetUserUnreadNotificationsCountQueryVariables = Exact<{
  technology: EnumNotificationTechnology;
}>;

export type TGetUserUnreadNotificationsCountQuery = {
  userUnreadNotificationsCount: number;
};

export type TUpdateNotificationMutationVariables = Exact<{
  updateNotificationId: Scalars['MongoID']['input'];
}>;

export type TUpdateNotificationMutation = {
  updateNotification?:
    | { record?: { _id: string; read: boolean } | undefined }
    | undefined;
};

export type TRemoveNotificationMutationVariables = Exact<{
  notificationId: Scalars['MongoID']['input'];
}>;

export type TRemoveNotificationMutation = {
  removeNotification?: { record?: { _id: string } | undefined } | undefined;
};

export type TGetPatientDraftExamsQueryVariables = Exact<{
  examsFilter: TFilterFindManyExamInput;
}>;

export type TGetPatientDraftExamsQuery = {
  exams: Array<{
    _id: string;
    examDate?: string | undefined;
    technology: EnumExamTechnology;
    device: string;
    priority?: EnumExamPriority | undefined;
    clinicalIndication?: string | undefined;
    models?: Array<string | undefined> | undefined;
    status?: EnumExamStatus | undefined;
    user?:
      | {
          firstName: string;
          lastName: string;
          firebaseId: string;
          institution?: { _id: string } | undefined;
        }
      | undefined;
    physician?: { _id: string } | undefined;
    medicalNotes?:
      | Array<
          | {
              _id: string;
              content: string;
              creationDate: string;
              user?:
                | { _id: string; firstName: string; lastName: string }
                | undefined;
            }
          | undefined
        >
      | undefined;
    media?:
      | {
          fullVideo?: string | undefined;
          frames?: Array<string | undefined> | undefined;
        }
      | undefined;
  }>;
};

export type TCreateExamMutationVariables = Exact<{
  record: TCreateOneExamInput;
}>;

export type TCreateExamMutation = {
  createExam?:
    | {
        record?:
          | {
              _id: string;
              technology: EnumExamTechnology;
              device: string;
              models?: Array<string | undefined> | undefined;
              status?: EnumExamStatus | undefined;
              user?:
                | { _id: string; institution?: { _id: string } | undefined }
                | undefined;
              physician?: { _id: string } | undefined;
              patient?: { _id: string } | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type TRemoveExamMutationVariables = Exact<{
  removeExamId: Scalars['MongoID']['input'];
}>;

export type TRemoveExamMutation = {
  removeExam?: { record?: { _id: string } | undefined } | undefined;
};

export type TPatientByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;

export type TPatientByIdQuery = {
  patient?:
    | { firstName: string; lastName: string; avatar?: string | undefined }
    | undefined;
};

export type TSearchPatientQueryVariables = Exact<{
  filter?: InputMaybe<TFilterFindOnePatientInput>;
}>;

export type TSearchPatientQuery = { patient?: { _id: string } | undefined };

export type TCreatePatientMutationVariables = Exact<{
  record: TCreateOnePatientInput;
}>;

export type TCreatePatientMutation = {
  createPatient?: { record?: { _id: string } | undefined } | undefined;
};

export type TRecentActivityQueryVariables = Exact<{
  filter: TFilterFindManyReducedExamInput;
  sort?: InputMaybe<SortFindManyReducedExamInput>;
}>;

export type TRecentActivityQuery = {
  recentActivity: Array<{
    _id: string;
    examDate?: string | undefined;
    technology: EnumReducedExamTechnology;
    priority?: EnumReducedExamPriority | undefined;
    relevantFindingsCount: number;
    detectionsCount: number;
    status: EnumReducedExamStatus;
    createdAt?: string | undefined;
    patient?:
      | {
          _id: string;
          firstName: string;
          lastName: string;
          identificationType: EnumReducedExamPatientIdentificationType;
          identificationNumber: string;
        }
      | undefined;
  }>;
};

export type TGetUserExamCountQueryVariables = Exact<{
  filter: TFilterCountExamInput;
}>;

export type TGetUserExamCountQuery = { examCount?: number | undefined };

export type TUpdateUserMutationVariables = Exact<{
  updateUserRecord: TUpdateByIdUserInput;
}>;

export type TUpdateUserMutation = {
  updateUser?:
    | {
        record?:
          | {
              _id: string;
              firstName: string;
              lastName: string;
              avatar?: string | undefined;
              biography?: string | undefined;
              license?: string | undefined;
              specialty?: string | undefined;
              country?: string | undefined;
              institution?: { _id: string } | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type TGetUserAccountInfoQueryVariables = Exact<{
  filter: TFilterFindOneUserInput;
}>;

export type TGetUserAccountInfoQuery = {
  user?:
    | {
        _id: string;
        firstName: string;
        lastName: string;
        avatar?: string | undefined;
        email?: string | undefined;
        biography?: string | undefined;
        license?: string | undefined;
        specialty?: string | undefined;
        phone?: string | undefined;
        country?: string | undefined;
        countryCallingCode?: string | undefined;
        institution?: { _id: string; name: string } | undefined;
      }
    | undefined;
};

export type TGetPatientDetailsQueryVariables = Exact<{
  patientId: Scalars['MongoID']['input'];
  technology: EnumExamTechnology;
}>;

export type TGetPatientDetailsQuery = {
  examCount?: number | undefined;
  allExamCount?: number | undefined;
  patient?:
    | {
        firstName: string;
        lastName: string;
        _id: string;
        birthDate?: string | undefined;
        identificationType: EnumPatientIdentificationType;
        identificationNumber: string;
        phone?: string | undefined;
        email?: string | undefined;
        country?: string | undefined;
        sex?: EnumPatientSex | undefined;
        ethnicity?: EnumPatientEthnicity | undefined;
      }
    | undefined;
};

export type TUpdatePatientDetailsMutationVariables = Exact<{
  updatePatientId: Scalars['MongoID']['input'];
  updatePatientRecord: TUpdateOnePatientInput;
}>;

export type TUpdatePatientDetailsMutation = {
  updatePatient?:
    | {
        record?:
          | {
              _id: string;
              firstName: string;
              lastName: string;
              birthDate?: string | undefined;
              identificationType: EnumPatientIdentificationType;
              identificationNumber: string;
              phone?: string | undefined;
              country?: string | undefined;
              email?: string | undefined;
              sex?: EnumPatientSex | undefined;
              ethnicity?: EnumPatientEthnicity | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type TRemovePatientByIdMutationVariables = Exact<{
  removePatientId: Scalars['MongoID']['input'];
}>;

export type TRemovePatientByIdMutation = {
  removePatientById?: boolean | undefined;
};

export type TExamCountQueryVariables = Exact<{
  filter: TFilterCountExamInput;
}>;

export type TExamCountQuery = { examCount?: number | undefined };

export type TPatientExamsQueryVariables = Exact<{
  examsFilter: TFilterFindManyReducedExamInput;
}>;

export type TPatientExamsQuery = {
  examsByPatient: Array<{
    _id: string;
    examDate?: string | undefined;
    relevantFindingsCount: number;
    technology: EnumReducedExamTechnology;
    priority?: EnumReducedExamPriority | undefined;
    detectionsCount: number;
    status: EnumReducedExamStatus;
    user?: { firstName: string; lastName: string } | undefined;
  }>;
};

export type TGetClinicalIndicationQueryVariables = Exact<{
  examId: Scalars['MongoID']['input'];
}>;

export type TGetClinicalIndicationQuery = {
  exam?:
    | {
        clinicalIndication?: string | undefined;
        user?: { _id: string } | undefined;
        physician?: { _id: string } | undefined;
      }
    | undefined;
};

export type TUpdateClinicalIndicationMutationVariables = Exact<{
  examId: Scalars['MongoID']['input'];
  clinicalIndication: Scalars['String']['input'];
}>;

export type TUpdateClinicalIndicationMutation = {
  updateExam?:
    | {
        record?:
          | { _id: string; clinicalIndication?: string | undefined }
          | undefined;
      }
    | undefined;
};

export type TGetMedicalNotesQueryVariables = Exact<{
  examId: Scalars['MongoID']['input'];
}>;

export type TGetMedicalNotesQuery = {
  exam?:
    | {
        _id: string;
        medicalNotes?:
          | Array<
              | {
                  _id: string;
                  content: string;
                  creationDate: string;
                  user?:
                    | { firstName: string; lastName: string; _id: string }
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type TCreateMedicalNoteMutationVariables = Exact<{
  examId: Scalars['MongoID']['input'];
  content: Scalars['String']['input'];
}>;

export type TCreateMedicalNoteMutation = {
  createMedicalNote?:
    | { medicalNotes?: Array<{ _id: string } | undefined> | undefined }
    | undefined;
};

export type TUpdateMedicalNoteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  examId: Scalars['MongoID']['input'];
  content: Scalars['String']['input'];
}>;

export type TUpdateMedicalNoteMutation = {
  updateMedicalNote?:
    | { medicalNotes?: Array<{ _id: string } | undefined> | undefined }
    | undefined;
};

export type TDeleteMedicalNoteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  examId: Scalars['MongoID']['input'];
}>;

export type TDeleteMedicalNoteMutation = {
  deleteMedicalNote?:
    | { medicalNotes?: Array<{ _id: string } | undefined> | undefined }
    | undefined;
};

export type TGetPatientExamDetailsQueryVariables = Exact<{
  examId: Scalars['MongoID']['input'];
  technology?: InputMaybe<EnumExamTechnology>;
}>;

export type TGetPatientExamDetailsQuery = {
  exam?:
    | {
        _id: string;
        examDate?: string | undefined;
        histologicalResult?: EnumExamHistologicalResult | undefined;
        priority?: EnumExamPriority | undefined;
        technology: EnumExamTechnology;
        device: string;
        clinicalIndication?: string | undefined;
        status?: EnumExamStatus | undefined;
        createdAt?: string | undefined;
        findings?:
          | Array<
              | {
                  _id?: string | undefined;
                  highlight?: boolean | undefined;
                  index: number;
                  timeStamp?: string | undefined;
                  location?: string | undefined;
                  frame: string;
                  thumbnail: string;
                  relevant?: boolean | undefined;
                  userLabel?: string | undefined;
                  targets?:
                    | Array<
                        | {
                            _id?: string | undefined;
                            code: string;
                            certainty: number;
                          }
                        | undefined
                      >
                    | undefined;
                }
              | undefined
            >
          | undefined;
        detectionResults?:
          | Array<
              | {
                  _id?: string | undefined;
                  origFilename: string;
                  origShape: Array<number | undefined>;
                  names: any;
                  detections?:
                    | Array<
                        | {
                            classId: number;
                            class: EnumExamDetectionResultsDetectionsClass;
                            confidence: number;
                            smartCystHistologicalResult?:
                              | EnumExamDetectionResultsDetectionsSmartCystHistologicalResult
                              | undefined;
                            smartPancreasHistologicalResult?:
                              | EnumExamDetectionResultsDetectionsSmartPancreasHistologicalResult
                              | undefined;
                            anoscopyGeniusHistologicalResult?:
                              | EnumExamDetectionResultsDetectionsAnoscopyGeniusHistologicalResult
                              | undefined;
                            position?: number | undefined;
                            box: {
                              left: number;
                              top: number;
                              right: number;
                              bottom: number;
                            };
                          }
                        | undefined
                      >
                    | undefined;
                }
              | undefined
            >
          | undefined;
        user?:
          | {
              _id: string;
              firstName: string;
              lastName: string;
              firebaseId: string;
              institution?: { _id: string } | undefined;
            }
          | undefined;
        physician?:
          | { _id: string; firstName: string; lastName: string }
          | undefined;
        media?:
          | {
              fullVideo?: string | undefined;
              highlights?: string | undefined;
              frames?: Array<string | undefined> | undefined;
            }
          | undefined;
        medicalNotes?:
          | Array<
              | {
                  _id: string;
                  content: string;
                  creationDate: string;
                  user?:
                    | { firstName: string; lastName: string; _id: string }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        laboratoryResult?:
          | { glucoseLevel?: number | undefined; ceaLevel?: number | undefined }
          | undefined;
      }
    | undefined;
};

export type TGetPatientExamEditDetailsQueryVariables = Exact<{
  examId: Scalars['MongoID']['input'];
  technology?: InputMaybe<EnumExamTechnology>;
}>;

export type TGetPatientExamEditDetailsQuery = {
  exam?:
    | {
        _id: string;
        examDate?: string | undefined;
        histologicalResult?: EnumExamHistologicalResult | undefined;
        clinicalIndication?: string | undefined;
        priority?: EnumExamPriority | undefined;
        status?: EnumExamStatus | undefined;
        user?:
          | {
              _id: string;
              firstName: string;
              lastName: string;
              firebaseId: string;
              institution?: { _id: string } | undefined;
            }
          | undefined;
        physician?:
          | { _id: string; firstName: string; lastName: string }
          | undefined;
        laboratoryResult?:
          | { glucoseLevel?: number | undefined; ceaLevel?: number | undefined }
          | undefined;
      }
    | undefined;
};

export type TUpdateExamDetectionHistologicalResultMutationVariables = Exact<{
  examId: Scalars['MongoID']['input'];
  detectionResultId: Scalars['MongoID']['input'];
  histologicalResult?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  technology: EnumExamTechnology;
}>;

export type TUpdateExamDetectionHistologicalResultMutation = {
  updateExamDetectionHistologicalResult?: { _id: string } | undefined;
};

export type TGetPatientListConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
}>;

export type TGetPatientListConnectionQuery = {
  patientListConnection?:
    | {
        pageInfo?:
          | {
              startCursor?: string | undefined;
              endCursor?: string | undefined;
              hasNextPage?: boolean | undefined;
              hasPreviousPage?: boolean | undefined;
            }
          | undefined;
        edges?:
          | Array<
              | {
                  cursor?: string | undefined;
                  node?:
                    | {
                        avatar?: string | undefined;
                        firstName: string;
                        lastName: string;
                        _id: string;
                        identificationNumber: string;
                        identificationType: EnumPatientIdentificationType;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type TGetExamsByUserConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  technology?: InputMaybe<EnumExamTechnology>;
  afterDate?: InputMaybe<Scalars['Date']['input']>;
  beforeDate?: InputMaybe<Scalars['Date']['input']>;
}>;

export type TGetExamsByUserConnectionQuery = {
  examsByUserConnection?:
    | {
        pageInfo: {
          startCursor?: string | undefined;
          endCursor?: string | undefined;
          hasNextPage?: boolean | undefined;
          hasPreviousPage?: boolean | undefined;
        };
        edges: Array<{
          cursor: string;
          node: {
            _id: string;
            examDate?: string | undefined;
            priority?: EnumReducedExamPriority | undefined;
            relevantFindingsCount: number;
            status: EnumReducedExamStatus;
            detectionsCount: number;
            histologicalResult?: EnumReducedExamHistologicalResult | undefined;
            user?: { fullName: string } | undefined;
            patient?:
              | {
                  _id: string;
                  firstName: string;
                  lastName: string;
                  fullName: string;
                  identificationNumber: string;
                  identificationType: EnumReducedExamPatientIdentificationType;
                }
              | undefined;
          };
        }>;
      }
    | undefined;
};

export type TGetExamValidationDataQueryVariables = Exact<{
  examId: Scalars['MongoID']['input'];
  technology?: InputMaybe<EnumExamTechnology>;
}>;

export type TGetExamValidationDataQuery = {
  exam?:
    | {
        _id: string;
        technology: EnumExamTechnology;
        filters?: any | undefined;
        user?:
          | {
              _id: string;
              firebaseId: string;
              institution?: { _id: string } | undefined;
            }
          | undefined;
        patient?: { _id: string } | undefined;
        physician?: { _id: string } | undefined;
        findings?:
          | Array<
              | {
                  _id?: string | undefined;
                  index: number;
                  timeStamp?: string | undefined;
                  location?: string | undefined;
                  frame: string;
                  thumbnail: string;
                  relevant?: boolean | undefined;
                  userLabel?: string | undefined;
                  targets?:
                    | Array<
                        | {
                            _id?: string | undefined;
                            code: string;
                            certainty: number;
                          }
                        | undefined
                      >
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type TValidateExamMutationVariables = Exact<{
  validateExamId: Scalars['MongoID']['input'];
  updatedFindings: Array<TInputUpdatedFinding>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type TValidateExamMutation = {
  validateExam?:
    | {
        _id: string;
        technology: EnumExamTechnology;
        filters?: any | undefined;
        user?:
          | {
              _id: string;
              firebaseId: string;
              institution?: { _id: string } | undefined;
            }
          | undefined;
        patient?: { _id: string } | undefined;
        physician?: { _id: string } | undefined;
      }
    | undefined;
};

export type TPatientSearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;

export type TPatientSearchQuery = {
  patientsSearch?:
    | {
        hasMoreResults?: boolean | undefined;
        patients?:
          | Array<
              | { _id: string; fullIdentification?: string | undefined }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type TGetUserSessionQueryVariables = Exact<{
  filter: TFilterFindOneUserInput;
}>;

export type TGetUserSessionQuery = {
  user?:
    | {
        _id: string;
        firebaseId: string;
        email?: string | undefined;
        firstName: string;
        lastName: string;
        avatar?: string | undefined;
        timezone: string;
        institution?:
          | {
              _id: string;
              name: string;
              dataAccessScope?: EnumInstitutionDataAccessScope | undefined;
            }
          | undefined;
      }
    | undefined;
};

export const NotificationFieldsFragmentDoc = gql`
  fragment NotificationFields on Notification {
    _id
    userId
    title
    description
    type
    exam {
      _id
      patient {
        _id
      }
    }
    read
    technology
  }
`;
export const GetExamForResubmitDocument = gql`
  query GetExamForResubmit($examId: MongoID!) {
    exam(filter: { _id: $examId }) {
      _id
      filters
      user {
        firebaseId
        institution {
          _id
        }
      }
    }
  }
`;

/**
 * __useGetExamForResubmitQuery__
 *
 * To run a query within a React component, call `useGetExamForResubmitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamForResubmitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamForResubmitQuery({
 *   variables: {
 *      examId: // value for 'examId'
 *   },
 * });
 */
export function useGetExamForResubmitQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetExamForResubmitQuery,
    TGetExamForResubmitQueryVariables
  > &
    (
      | { variables: TGetExamForResubmitQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetExamForResubmitQuery,
    TGetExamForResubmitQueryVariables
  >(GetExamForResubmitDocument, options);
}
export function useGetExamForResubmitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetExamForResubmitQuery,
    TGetExamForResubmitQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetExamForResubmitQuery,
    TGetExamForResubmitQueryVariables
  >(GetExamForResubmitDocument, options);
}
// @ts-ignore
export function useGetExamForResubmitSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetExamForResubmitQuery,
    TGetExamForResubmitQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetExamForResubmitQuery,
  TGetExamForResubmitQueryVariables
>;
export function useGetExamForResubmitSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetExamForResubmitQuery,
        TGetExamForResubmitQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetExamForResubmitQuery | undefined,
  TGetExamForResubmitQueryVariables
>;
export function useGetExamForResubmitSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetExamForResubmitQuery,
        TGetExamForResubmitQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetExamForResubmitQuery,
    TGetExamForResubmitQueryVariables
  >(GetExamForResubmitDocument, options);
}
export type GetExamForResubmitQueryHookResult = ReturnType<
  typeof useGetExamForResubmitQuery
>;
export type GetExamForResubmitLazyQueryHookResult = ReturnType<
  typeof useGetExamForResubmitLazyQuery
>;
export type GetExamForResubmitSuspenseQueryHookResult = ReturnType<
  typeof useGetExamForResubmitSuspenseQuery
>;
export type GetExamForResubmitQueryResult = Apollo.QueryResult<
  TGetExamForResubmitQuery,
  TGetExamForResubmitQueryVariables
>;
export const GetExamForReuploadDocument = gql`
  query GetExamForReupload($examId: MongoID!) {
    exam(filter: { _id: $examId }) {
      _id
      technology
      device
      user {
        firebaseId
        institution {
          _id
        }
      }
    }
  }
`;

/**
 * __useGetExamForReuploadQuery__
 *
 * To run a query within a React component, call `useGetExamForReuploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamForReuploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamForReuploadQuery({
 *   variables: {
 *      examId: // value for 'examId'
 *   },
 * });
 */
export function useGetExamForReuploadQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetExamForReuploadQuery,
    TGetExamForReuploadQueryVariables
  > &
    (
      | { variables: TGetExamForReuploadQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetExamForReuploadQuery,
    TGetExamForReuploadQueryVariables
  >(GetExamForReuploadDocument, options);
}
export function useGetExamForReuploadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetExamForReuploadQuery,
    TGetExamForReuploadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetExamForReuploadQuery,
    TGetExamForReuploadQueryVariables
  >(GetExamForReuploadDocument, options);
}
// @ts-ignore
export function useGetExamForReuploadSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetExamForReuploadQuery,
    TGetExamForReuploadQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetExamForReuploadQuery,
  TGetExamForReuploadQueryVariables
>;
export function useGetExamForReuploadSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetExamForReuploadQuery,
        TGetExamForReuploadQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetExamForReuploadQuery | undefined,
  TGetExamForReuploadQueryVariables
>;
export function useGetExamForReuploadSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetExamForReuploadQuery,
        TGetExamForReuploadQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetExamForReuploadQuery,
    TGetExamForReuploadQueryVariables
  >(GetExamForReuploadDocument, options);
}
export type GetExamForReuploadQueryHookResult = ReturnType<
  typeof useGetExamForReuploadQuery
>;
export type GetExamForReuploadLazyQueryHookResult = ReturnType<
  typeof useGetExamForReuploadLazyQuery
>;
export type GetExamForReuploadSuspenseQueryHookResult = ReturnType<
  typeof useGetExamForReuploadSuspenseQuery
>;
export type GetExamForReuploadQueryResult = Apollo.QueryResult<
  TGetExamForReuploadQuery,
  TGetExamForReuploadQueryVariables
>;
export const UpdateExamDocument = gql`
  mutation UpdateExam(
    $updateExamId: MongoID!
    $updateExamRecord: UpdateByIdExamInput!
  ) {
    updateExam(_id: $updateExamId, record: $updateExamRecord) {
      record {
        _id
        technology
        device
        examDate
        clinicalIndication
        histologicalResult
        laboratoryResult {
          glucoseLevel
          ceaLevel
        }
        status
        filters
        priority
        user {
          _id
          institution {
            _id
          }
        }
        physician {
          _id
        }
        media {
          fullVideo
          highlights
          frames
        }
        models
        medicalNotes {
          _id
          content
          user {
            _id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
export type TUpdateExamMutationFn = Apollo.MutationFunction<
  TUpdateExamMutation,
  TUpdateExamMutationVariables
>;

/**
 * __useUpdateExamMutation__
 *
 * To run a mutation, you first call `useUpdateExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamMutation, { data, loading, error }] = useUpdateExamMutation({
 *   variables: {
 *      updateExamId: // value for 'updateExamId'
 *      updateExamRecord: // value for 'updateExamRecord'
 *   },
 * });
 */
export function useUpdateExamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TUpdateExamMutation,
    TUpdateExamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateExamMutation, TUpdateExamMutationVariables>(
    UpdateExamDocument,
    options,
  );
}
export type UpdateExamMutationHookResult = ReturnType<
  typeof useUpdateExamMutation
>;
export type UpdateExamMutationResult =
  Apollo.MutationResult<TUpdateExamMutation>;
export type UpdateExamMutationOptions = Apollo.BaseMutationOptions<
  TUpdateExamMutation,
  TUpdateExamMutationVariables
>;
export const GetExamStatusDocument = gql`
  query GetExamStatus($examId: MongoID!) {
    exam(filter: { _id: $examId }) {
      status
    }
  }
`;

/**
 * __useGetExamStatusQuery__
 *
 * To run a query within a React component, call `useGetExamStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamStatusQuery({
 *   variables: {
 *      examId: // value for 'examId'
 *   },
 * });
 */
export function useGetExamStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetExamStatusQuery,
    TGetExamStatusQueryVariables
  > &
    (
      | { variables: TGetExamStatusQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetExamStatusQuery, TGetExamStatusQueryVariables>(
    GetExamStatusDocument,
    options,
  );
}
export function useGetExamStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetExamStatusQuery,
    TGetExamStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetExamStatusQuery, TGetExamStatusQueryVariables>(
    GetExamStatusDocument,
    options,
  );
}
// @ts-ignore
export function useGetExamStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetExamStatusQuery,
    TGetExamStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetExamStatusQuery,
  TGetExamStatusQueryVariables
>;
export function useGetExamStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetExamStatusQuery,
        TGetExamStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetExamStatusQuery | undefined,
  TGetExamStatusQueryVariables
>;
export function useGetExamStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetExamStatusQuery,
        TGetExamStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetExamStatusQuery,
    TGetExamStatusQueryVariables
  >(GetExamStatusDocument, options);
}
export type GetExamStatusQueryHookResult = ReturnType<
  typeof useGetExamStatusQuery
>;
export type GetExamStatusLazyQueryHookResult = ReturnType<
  typeof useGetExamStatusLazyQuery
>;
export type GetExamStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetExamStatusSuspenseQuery
>;
export type GetExamStatusQueryResult = Apollo.QueryResult<
  TGetExamStatusQuery,
  TGetExamStatusQueryVariables
>;
export const GetUsersDocument = gql`
  query GetUsers($sort: SortFindManyUserInput) {
    users(sort: $sort) {
      _id
      firstName
      lastName
      avatar
    }
  }
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TGetUsersQuery,
    TGetUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetUsersQuery, TGetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetUsersQuery,
    TGetUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetUsersQuery, TGetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
// @ts-ignore
export function useGetUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetUsersQuery,
    TGetUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TGetUsersQuery, TGetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TGetUsersQuery, TGetUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  TGetUsersQuery | undefined,
  TGetUsersQueryVariables
>;
export function useGetUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TGetUsersQuery, TGetUsersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetUsersQuery, TGetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<
  typeof useGetUsersLazyQuery
>;
export type GetUsersSuspenseQueryHookResult = ReturnType<
  typeof useGetUsersSuspenseQuery
>;
export type GetUsersQueryResult = Apollo.QueryResult<
  TGetUsersQuery,
  TGetUsersQueryVariables
>;
export const RemoveExamNotificationsDocument = gql`
  mutation RemoveExamNotifications(
    $examId: MongoID!
    $notificationType: EnumNotificationType!
  ) {
    removeExamNotifications(
      examId: $examId
      notificationType: $notificationType
    ) {
      deletedCount
    }
  }
`;
export type TRemoveExamNotificationsMutationFn = Apollo.MutationFunction<
  TRemoveExamNotificationsMutation,
  TRemoveExamNotificationsMutationVariables
>;

/**
 * __useRemoveExamNotificationsMutation__
 *
 * To run a mutation, you first call `useRemoveExamNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExamNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExamNotificationsMutation, { data, loading, error }] = useRemoveExamNotificationsMutation({
 *   variables: {
 *      examId: // value for 'examId'
 *      notificationType: // value for 'notificationType'
 *   },
 * });
 */
export function useRemoveExamNotificationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TRemoveExamNotificationsMutation,
    TRemoveExamNotificationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TRemoveExamNotificationsMutation,
    TRemoveExamNotificationsMutationVariables
  >(RemoveExamNotificationsDocument, options);
}
export type RemoveExamNotificationsMutationHookResult = ReturnType<
  typeof useRemoveExamNotificationsMutation
>;
export type RemoveExamNotificationsMutationResult =
  Apollo.MutationResult<TRemoveExamNotificationsMutation>;
export type RemoveExamNotificationsMutationOptions = Apollo.BaseMutationOptions<
  TRemoveExamNotificationsMutation,
  TRemoveExamNotificationsMutationVariables
>;
export const UpdateExamFindingHighlightDocument = gql`
  mutation UpdateExamFindingHighlight(
    $updateExamId: MongoID!
    $updateFindingIndex: Int!
    $updateFindingHighlight: Boolean!
  ) {
    updateExamFindingHighlight(
      _id: $updateExamId
      findingIndex: $updateFindingIndex
      findingHighlight: $updateFindingHighlight
    ) {
      _id
      highlight
    }
  }
`;
export type TUpdateExamFindingHighlightMutationFn = Apollo.MutationFunction<
  TUpdateExamFindingHighlightMutation,
  TUpdateExamFindingHighlightMutationVariables
>;

/**
 * __useUpdateExamFindingHighlightMutation__
 *
 * To run a mutation, you first call `useUpdateExamFindingHighlightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamFindingHighlightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamFindingHighlightMutation, { data, loading, error }] = useUpdateExamFindingHighlightMutation({
 *   variables: {
 *      updateExamId: // value for 'updateExamId'
 *      updateFindingIndex: // value for 'updateFindingIndex'
 *      updateFindingHighlight: // value for 'updateFindingHighlight'
 *   },
 * });
 */
export function useUpdateExamFindingHighlightMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TUpdateExamFindingHighlightMutation,
    TUpdateExamFindingHighlightMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TUpdateExamFindingHighlightMutation,
    TUpdateExamFindingHighlightMutationVariables
  >(UpdateExamFindingHighlightDocument, options);
}
export type UpdateExamFindingHighlightMutationHookResult = ReturnType<
  typeof useUpdateExamFindingHighlightMutation
>;
export type UpdateExamFindingHighlightMutationResult =
  Apollo.MutationResult<TUpdateExamFindingHighlightMutation>;
export type UpdateExamFindingHighlightMutationOptions =
  Apollo.BaseMutationOptions<
    TUpdateExamFindingHighlightMutation,
    TUpdateExamFindingHighlightMutationVariables
  >;
export const GetUserNotificationsConnectionDocument = gql`
  query GetUserNotificationsConnection(
    $first: Int
    $after: String
    $technology: EnumNotificationTechnology!
  ) {
    userNotificationsConnection(
      first: $first
      after: $after
      technology: $technology
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          ...NotificationFields
        }
      }
    }
  }
  ${NotificationFieldsFragmentDoc}
`;

/**
 * __useGetUserNotificationsConnectionQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsConnectionQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      technology: // value for 'technology'
 *   },
 * });
 */
export function useGetUserNotificationsConnectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetUserNotificationsConnectionQuery,
    TGetUserNotificationsConnectionQueryVariables
  > &
    (
      | {
          variables: TGetUserNotificationsConnectionQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetUserNotificationsConnectionQuery,
    TGetUserNotificationsConnectionQueryVariables
  >(GetUserNotificationsConnectionDocument, options);
}
export function useGetUserNotificationsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetUserNotificationsConnectionQuery,
    TGetUserNotificationsConnectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetUserNotificationsConnectionQuery,
    TGetUserNotificationsConnectionQueryVariables
  >(GetUserNotificationsConnectionDocument, options);
}
// @ts-ignore
export function useGetUserNotificationsConnectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetUserNotificationsConnectionQuery,
    TGetUserNotificationsConnectionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetUserNotificationsConnectionQuery,
  TGetUserNotificationsConnectionQueryVariables
>;
export function useGetUserNotificationsConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetUserNotificationsConnectionQuery,
        TGetUserNotificationsConnectionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetUserNotificationsConnectionQuery | undefined,
  TGetUserNotificationsConnectionQueryVariables
>;
export function useGetUserNotificationsConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetUserNotificationsConnectionQuery,
        TGetUserNotificationsConnectionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetUserNotificationsConnectionQuery,
    TGetUserNotificationsConnectionQueryVariables
  >(GetUserNotificationsConnectionDocument, options);
}
export type GetUserNotificationsConnectionQueryHookResult = ReturnType<
  typeof useGetUserNotificationsConnectionQuery
>;
export type GetUserNotificationsConnectionLazyQueryHookResult = ReturnType<
  typeof useGetUserNotificationsConnectionLazyQuery
>;
export type GetUserNotificationsConnectionSuspenseQueryHookResult = ReturnType<
  typeof useGetUserNotificationsConnectionSuspenseQuery
>;
export type GetUserNotificationsConnectionQueryResult = Apollo.QueryResult<
  TGetUserNotificationsConnectionQuery,
  TGetUserNotificationsConnectionQueryVariables
>;
export const GetUserUnreadNotificationsCountDocument = gql`
  query GetUserUnreadNotificationsCount(
    $technology: EnumNotificationTechnology!
  ) {
    userUnreadNotificationsCount(technology: $technology)
  }
`;

/**
 * __useGetUserUnreadNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetUserUnreadNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserUnreadNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserUnreadNotificationsCountQuery({
 *   variables: {
 *      technology: // value for 'technology'
 *   },
 * });
 */
export function useGetUserUnreadNotificationsCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetUserUnreadNotificationsCountQuery,
    TGetUserUnreadNotificationsCountQueryVariables
  > &
    (
      | {
          variables: TGetUserUnreadNotificationsCountQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetUserUnreadNotificationsCountQuery,
    TGetUserUnreadNotificationsCountQueryVariables
  >(GetUserUnreadNotificationsCountDocument, options);
}
export function useGetUserUnreadNotificationsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetUserUnreadNotificationsCountQuery,
    TGetUserUnreadNotificationsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetUserUnreadNotificationsCountQuery,
    TGetUserUnreadNotificationsCountQueryVariables
  >(GetUserUnreadNotificationsCountDocument, options);
}
// @ts-ignore
export function useGetUserUnreadNotificationsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetUserUnreadNotificationsCountQuery,
    TGetUserUnreadNotificationsCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetUserUnreadNotificationsCountQuery,
  TGetUserUnreadNotificationsCountQueryVariables
>;
export function useGetUserUnreadNotificationsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetUserUnreadNotificationsCountQuery,
        TGetUserUnreadNotificationsCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetUserUnreadNotificationsCountQuery | undefined,
  TGetUserUnreadNotificationsCountQueryVariables
>;
export function useGetUserUnreadNotificationsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetUserUnreadNotificationsCountQuery,
        TGetUserUnreadNotificationsCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetUserUnreadNotificationsCountQuery,
    TGetUserUnreadNotificationsCountQueryVariables
  >(GetUserUnreadNotificationsCountDocument, options);
}
export type GetUserUnreadNotificationsCountQueryHookResult = ReturnType<
  typeof useGetUserUnreadNotificationsCountQuery
>;
export type GetUserUnreadNotificationsCountLazyQueryHookResult = ReturnType<
  typeof useGetUserUnreadNotificationsCountLazyQuery
>;
export type GetUserUnreadNotificationsCountSuspenseQueryHookResult = ReturnType<
  typeof useGetUserUnreadNotificationsCountSuspenseQuery
>;
export type GetUserUnreadNotificationsCountQueryResult = Apollo.QueryResult<
  TGetUserUnreadNotificationsCountQuery,
  TGetUserUnreadNotificationsCountQueryVariables
>;
export const UpdateNotificationDocument = gql`
  mutation UpdateNotification($updateNotificationId: MongoID!) {
    updateNotification(
      filter: { _id: $updateNotificationId }
      record: { read: true }
    ) {
      record {
        _id
        read
      }
    }
  }
`;
export type TUpdateNotificationMutationFn = Apollo.MutationFunction<
  TUpdateNotificationMutation,
  TUpdateNotificationMutationVariables
>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      updateNotificationId: // value for 'updateNotificationId'
 *   },
 * });
 */
export function useUpdateNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TUpdateNotificationMutation,
    TUpdateNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TUpdateNotificationMutation,
    TUpdateNotificationMutationVariables
  >(UpdateNotificationDocument, options);
}
export type UpdateNotificationMutationHookResult = ReturnType<
  typeof useUpdateNotificationMutation
>;
export type UpdateNotificationMutationResult =
  Apollo.MutationResult<TUpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<
  TUpdateNotificationMutation,
  TUpdateNotificationMutationVariables
>;
export const RemoveNotificationDocument = gql`
  mutation RemoveNotification($notificationId: MongoID!) {
    removeNotification(filter: { _id: $notificationId }) {
      record {
        _id
      }
    }
  }
`;
export type TRemoveNotificationMutationFn = Apollo.MutationFunction<
  TRemoveNotificationMutation,
  TRemoveNotificationMutationVariables
>;

/**
 * __useRemoveNotificationMutation__
 *
 * To run a mutation, you first call `useRemoveNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNotificationMutation, { data, loading, error }] = useRemoveNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useRemoveNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TRemoveNotificationMutation,
    TRemoveNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TRemoveNotificationMutation,
    TRemoveNotificationMutationVariables
  >(RemoveNotificationDocument, options);
}
export type RemoveNotificationMutationHookResult = ReturnType<
  typeof useRemoveNotificationMutation
>;
export type RemoveNotificationMutationResult =
  Apollo.MutationResult<TRemoveNotificationMutation>;
export type RemoveNotificationMutationOptions = Apollo.BaseMutationOptions<
  TRemoveNotificationMutation,
  TRemoveNotificationMutationVariables
>;
export const GetPatientDraftExamsDocument = gql`
  query GetPatientDraftExams($examsFilter: FilterFindManyExamInput!) {
    exams(filter: $examsFilter, sort: CREATED_AT_DESC) {
      _id
      examDate
      technology
      device
      priority
      user {
        firstName
        lastName
        firebaseId
        institution {
          _id
        }
      }
      physician {
        _id
      }
      medicalNotes {
        _id
        user {
          _id
          firstName
          lastName
        }
        content
        creationDate
      }
      clinicalIndication
      models
      status
      media {
        fullVideo
        frames
      }
    }
  }
`;

/**
 * __useGetPatientDraftExamsQuery__
 *
 * To run a query within a React component, call `useGetPatientDraftExamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientDraftExamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientDraftExamsQuery({
 *   variables: {
 *      examsFilter: // value for 'examsFilter'
 *   },
 * });
 */
export function useGetPatientDraftExamsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetPatientDraftExamsQuery,
    TGetPatientDraftExamsQueryVariables
  > &
    (
      | { variables: TGetPatientDraftExamsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetPatientDraftExamsQuery,
    TGetPatientDraftExamsQueryVariables
  >(GetPatientDraftExamsDocument, options);
}
export function useGetPatientDraftExamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetPatientDraftExamsQuery,
    TGetPatientDraftExamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetPatientDraftExamsQuery,
    TGetPatientDraftExamsQueryVariables
  >(GetPatientDraftExamsDocument, options);
}
// @ts-ignore
export function useGetPatientDraftExamsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetPatientDraftExamsQuery,
    TGetPatientDraftExamsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetPatientDraftExamsQuery,
  TGetPatientDraftExamsQueryVariables
>;
export function useGetPatientDraftExamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetPatientDraftExamsQuery,
        TGetPatientDraftExamsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetPatientDraftExamsQuery | undefined,
  TGetPatientDraftExamsQueryVariables
>;
export function useGetPatientDraftExamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetPatientDraftExamsQuery,
        TGetPatientDraftExamsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetPatientDraftExamsQuery,
    TGetPatientDraftExamsQueryVariables
  >(GetPatientDraftExamsDocument, options);
}
export type GetPatientDraftExamsQueryHookResult = ReturnType<
  typeof useGetPatientDraftExamsQuery
>;
export type GetPatientDraftExamsLazyQueryHookResult = ReturnType<
  typeof useGetPatientDraftExamsLazyQuery
>;
export type GetPatientDraftExamsSuspenseQueryHookResult = ReturnType<
  typeof useGetPatientDraftExamsSuspenseQuery
>;
export type GetPatientDraftExamsQueryResult = Apollo.QueryResult<
  TGetPatientDraftExamsQuery,
  TGetPatientDraftExamsQueryVariables
>;
export const CreateExamDocument = gql`
  mutation CreateExam($record: CreateOneExamInput!) {
    createExam(record: $record) {
      record {
        _id
        user {
          _id
          institution {
            _id
          }
        }
        physician {
          _id
        }
        patient {
          _id
        }
        technology
        device
        models
        status
      }
    }
  }
`;
export type TCreateExamMutationFn = Apollo.MutationFunction<
  TCreateExamMutation,
  TCreateExamMutationVariables
>;

/**
 * __useCreateExamMutation__
 *
 * To run a mutation, you first call `useCreateExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExamMutation, { data, loading, error }] = useCreateExamMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCreateExamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TCreateExamMutation,
    TCreateExamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateExamMutation, TCreateExamMutationVariables>(
    CreateExamDocument,
    options,
  );
}
export type CreateExamMutationHookResult = ReturnType<
  typeof useCreateExamMutation
>;
export type CreateExamMutationResult =
  Apollo.MutationResult<TCreateExamMutation>;
export type CreateExamMutationOptions = Apollo.BaseMutationOptions<
  TCreateExamMutation,
  TCreateExamMutationVariables
>;
export const RemoveExamDocument = gql`
  mutation RemoveExam($removeExamId: MongoID!) {
    removeExam(_id: $removeExamId) {
      record {
        _id
      }
    }
  }
`;
export type TRemoveExamMutationFn = Apollo.MutationFunction<
  TRemoveExamMutation,
  TRemoveExamMutationVariables
>;

/**
 * __useRemoveExamMutation__
 *
 * To run a mutation, you first call `useRemoveExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExamMutation, { data, loading, error }] = useRemoveExamMutation({
 *   variables: {
 *      removeExamId: // value for 'removeExamId'
 *   },
 * });
 */
export function useRemoveExamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TRemoveExamMutation,
    TRemoveExamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TRemoveExamMutation, TRemoveExamMutationVariables>(
    RemoveExamDocument,
    options,
  );
}
export type RemoveExamMutationHookResult = ReturnType<
  typeof useRemoveExamMutation
>;
export type RemoveExamMutationResult =
  Apollo.MutationResult<TRemoveExamMutation>;
export type RemoveExamMutationOptions = Apollo.BaseMutationOptions<
  TRemoveExamMutation,
  TRemoveExamMutationVariables
>;
export const PatientByIdDocument = gql`
  query PatientById($id: MongoID!) {
    patient(filter: { _id: $id }) {
      firstName
      lastName
      avatar
    }
  }
`;

/**
 * __usePatientByIdQuery__
 *
 * To run a query within a React component, call `usePatientByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePatientByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    TPatientByIdQuery,
    TPatientByIdQueryVariables
  > &
    (
      | { variables: TPatientByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TPatientByIdQuery, TPatientByIdQueryVariables>(
    PatientByIdDocument,
    options,
  );
}
export function usePatientByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TPatientByIdQuery,
    TPatientByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TPatientByIdQuery, TPatientByIdQueryVariables>(
    PatientByIdDocument,
    options,
  );
}
// @ts-ignore
export function usePatientByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TPatientByIdQuery,
    TPatientByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TPatientByIdQuery, TPatientByIdQueryVariables>;
export function usePatientByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TPatientByIdQuery,
        TPatientByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TPatientByIdQuery | undefined,
  TPatientByIdQueryVariables
>;
export function usePatientByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TPatientByIdQuery,
        TPatientByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TPatientByIdQuery, TPatientByIdQueryVariables>(
    PatientByIdDocument,
    options,
  );
}
export type PatientByIdQueryHookResult = ReturnType<typeof usePatientByIdQuery>;
export type PatientByIdLazyQueryHookResult = ReturnType<
  typeof usePatientByIdLazyQuery
>;
export type PatientByIdSuspenseQueryHookResult = ReturnType<
  typeof usePatientByIdSuspenseQuery
>;
export type PatientByIdQueryResult = Apollo.QueryResult<
  TPatientByIdQuery,
  TPatientByIdQueryVariables
>;
export const SearchPatientDocument = gql`
  query SearchPatient($filter: FilterFindOnePatientInput) {
    patient(filter: $filter) {
      _id
    }
  }
`;

/**
 * __useSearchPatientQuery__
 *
 * To run a query within a React component, call `useSearchPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPatientQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchPatientQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TSearchPatientQuery,
    TSearchPatientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TSearchPatientQuery, TSearchPatientQueryVariables>(
    SearchPatientDocument,
    options,
  );
}
export function useSearchPatientLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TSearchPatientQuery,
    TSearchPatientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TSearchPatientQuery, TSearchPatientQueryVariables>(
    SearchPatientDocument,
    options,
  );
}
// @ts-ignore
export function useSearchPatientSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TSearchPatientQuery,
    TSearchPatientQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TSearchPatientQuery,
  TSearchPatientQueryVariables
>;
export function useSearchPatientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TSearchPatientQuery,
        TSearchPatientQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TSearchPatientQuery | undefined,
  TSearchPatientQueryVariables
>;
export function useSearchPatientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TSearchPatientQuery,
        TSearchPatientQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TSearchPatientQuery,
    TSearchPatientQueryVariables
  >(SearchPatientDocument, options);
}
export type SearchPatientQueryHookResult = ReturnType<
  typeof useSearchPatientQuery
>;
export type SearchPatientLazyQueryHookResult = ReturnType<
  typeof useSearchPatientLazyQuery
>;
export type SearchPatientSuspenseQueryHookResult = ReturnType<
  typeof useSearchPatientSuspenseQuery
>;
export type SearchPatientQueryResult = Apollo.QueryResult<
  TSearchPatientQuery,
  TSearchPatientQueryVariables
>;
export const CreatePatientDocument = gql`
  mutation CreatePatient($record: CreateOnePatientInput!) {
    createPatient(record: $record) {
      record {
        _id
      }
    }
  }
`;
export type TCreatePatientMutationFn = Apollo.MutationFunction<
  TCreatePatientMutation,
  TCreatePatientMutationVariables
>;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientMutation, { data, loading, error }] = useCreatePatientMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCreatePatientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TCreatePatientMutation,
    TCreatePatientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TCreatePatientMutation,
    TCreatePatientMutationVariables
  >(CreatePatientDocument, options);
}
export type CreatePatientMutationHookResult = ReturnType<
  typeof useCreatePatientMutation
>;
export type CreatePatientMutationResult =
  Apollo.MutationResult<TCreatePatientMutation>;
export type CreatePatientMutationOptions = Apollo.BaseMutationOptions<
  TCreatePatientMutation,
  TCreatePatientMutationVariables
>;
export const RecentActivityDocument = gql`
  query RecentActivity(
    $filter: FilterFindManyReducedExamInput!
    $sort: SortFindManyReducedExamInput
  ) {
    recentActivity(filter: $filter, sort: $sort) {
      _id
      examDate
      technology
      priority
      patient {
        _id
        firstName
        lastName
        identificationType
        identificationNumber
      }
      relevantFindingsCount
      detectionsCount
      status
      createdAt
    }
  }
`;

/**
 * __useRecentActivityQuery__
 *
 * To run a query within a React component, call `useRecentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentActivityQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useRecentActivityQuery(
  baseOptions: Apollo.QueryHookOptions<
    TRecentActivityQuery,
    TRecentActivityQueryVariables
  > &
    (
      | { variables: TRecentActivityQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TRecentActivityQuery, TRecentActivityQueryVariables>(
    RecentActivityDocument,
    options,
  );
}
export function useRecentActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TRecentActivityQuery,
    TRecentActivityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TRecentActivityQuery,
    TRecentActivityQueryVariables
  >(RecentActivityDocument, options);
}
// @ts-ignore
export function useRecentActivitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TRecentActivityQuery,
    TRecentActivityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TRecentActivityQuery,
  TRecentActivityQueryVariables
>;
export function useRecentActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TRecentActivityQuery,
        TRecentActivityQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TRecentActivityQuery | undefined,
  TRecentActivityQueryVariables
>;
export function useRecentActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TRecentActivityQuery,
        TRecentActivityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TRecentActivityQuery,
    TRecentActivityQueryVariables
  >(RecentActivityDocument, options);
}
export type RecentActivityQueryHookResult = ReturnType<
  typeof useRecentActivityQuery
>;
export type RecentActivityLazyQueryHookResult = ReturnType<
  typeof useRecentActivityLazyQuery
>;
export type RecentActivitySuspenseQueryHookResult = ReturnType<
  typeof useRecentActivitySuspenseQuery
>;
export type RecentActivityQueryResult = Apollo.QueryResult<
  TRecentActivityQuery,
  TRecentActivityQueryVariables
>;
export const GetUserExamCountDocument = gql`
  query GetUserExamCount($filter: FilterCountExamInput!) {
    examCount(filter: $filter)
  }
`;

/**
 * __useGetUserExamCountQuery__
 *
 * To run a query within a React component, call `useGetUserExamCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserExamCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserExamCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUserExamCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetUserExamCountQuery,
    TGetUserExamCountQueryVariables
  > &
    (
      | { variables: TGetUserExamCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetUserExamCountQuery,
    TGetUserExamCountQueryVariables
  >(GetUserExamCountDocument, options);
}
export function useGetUserExamCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetUserExamCountQuery,
    TGetUserExamCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetUserExamCountQuery,
    TGetUserExamCountQueryVariables
  >(GetUserExamCountDocument, options);
}
// @ts-ignore
export function useGetUserExamCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetUserExamCountQuery,
    TGetUserExamCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetUserExamCountQuery,
  TGetUserExamCountQueryVariables
>;
export function useGetUserExamCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetUserExamCountQuery,
        TGetUserExamCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetUserExamCountQuery | undefined,
  TGetUserExamCountQueryVariables
>;
export function useGetUserExamCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetUserExamCountQuery,
        TGetUserExamCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetUserExamCountQuery,
    TGetUserExamCountQueryVariables
  >(GetUserExamCountDocument, options);
}
export type GetUserExamCountQueryHookResult = ReturnType<
  typeof useGetUserExamCountQuery
>;
export type GetUserExamCountLazyQueryHookResult = ReturnType<
  typeof useGetUserExamCountLazyQuery
>;
export type GetUserExamCountSuspenseQueryHookResult = ReturnType<
  typeof useGetUserExamCountSuspenseQuery
>;
export type GetUserExamCountQueryResult = Apollo.QueryResult<
  TGetUserExamCountQuery,
  TGetUserExamCountQueryVariables
>;
export const UpdateUserDocument = gql`
  mutation UpdateUser($updateUserRecord: UpdateByIdUserInput!) {
    updateUser(record: $updateUserRecord) {
      record {
        _id
        firstName
        lastName
        avatar
        biography
        institution {
          _id
        }
        license
        specialty
        country
      }
    }
  }
`;
export type TUpdateUserMutationFn = Apollo.MutationFunction<
  TUpdateUserMutation,
  TUpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateUserRecord: // value for 'updateUserRecord'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TUpdateUserMutation,
    TUpdateUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateUserMutation, TUpdateUserMutationVariables>(
    UpdateUserDocument,
    options,
  );
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>;
export type UpdateUserMutationResult =
  Apollo.MutationResult<TUpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  TUpdateUserMutation,
  TUpdateUserMutationVariables
>;
export const GetUserAccountInfoDocument = gql`
  query GetUserAccountInfo($filter: FilterFindOneUserInput!) {
    user(filter: $filter) {
      _id
      firstName
      lastName
      avatar
      email
      biography
      license
      specialty
      phone
      country
      countryCallingCode
      institution {
        _id
        name
      }
    }
  }
`;

/**
 * __useGetUserAccountInfoQuery__
 *
 * To run a query within a React component, call `useGetUserAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccountInfoQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUserAccountInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetUserAccountInfoQuery,
    TGetUserAccountInfoQueryVariables
  > &
    (
      | { variables: TGetUserAccountInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetUserAccountInfoQuery,
    TGetUserAccountInfoQueryVariables
  >(GetUserAccountInfoDocument, options);
}
export function useGetUserAccountInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetUserAccountInfoQuery,
    TGetUserAccountInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetUserAccountInfoQuery,
    TGetUserAccountInfoQueryVariables
  >(GetUserAccountInfoDocument, options);
}
// @ts-ignore
export function useGetUserAccountInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetUserAccountInfoQuery,
    TGetUserAccountInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetUserAccountInfoQuery,
  TGetUserAccountInfoQueryVariables
>;
export function useGetUserAccountInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetUserAccountInfoQuery,
        TGetUserAccountInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetUserAccountInfoQuery | undefined,
  TGetUserAccountInfoQueryVariables
>;
export function useGetUserAccountInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetUserAccountInfoQuery,
        TGetUserAccountInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetUserAccountInfoQuery,
    TGetUserAccountInfoQueryVariables
  >(GetUserAccountInfoDocument, options);
}
export type GetUserAccountInfoQueryHookResult = ReturnType<
  typeof useGetUserAccountInfoQuery
>;
export type GetUserAccountInfoLazyQueryHookResult = ReturnType<
  typeof useGetUserAccountInfoLazyQuery
>;
export type GetUserAccountInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetUserAccountInfoSuspenseQuery
>;
export type GetUserAccountInfoQueryResult = Apollo.QueryResult<
  TGetUserAccountInfoQuery,
  TGetUserAccountInfoQueryVariables
>;
export const GetPatientDetailsDocument = gql`
  query GetPatientDetails(
    $patientId: MongoID!
    $technology: EnumExamTechnology!
  ) {
    patient(filter: { _id: $patientId }) {
      firstName
      lastName
      _id
      birthDate
      identificationType
      identificationNumber
      phone
      email
      country
      sex
      ethnicity
    }
    allExamCount: examCount(filter: { patient: $patientId })
    examCount(filter: { patient: $patientId, technology: $technology })
  }
`;

/**
 * __useGetPatientDetailsQuery__
 *
 * To run a query within a React component, call `useGetPatientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientDetailsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      technology: // value for 'technology'
 *   },
 * });
 */
export function useGetPatientDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetPatientDetailsQuery,
    TGetPatientDetailsQueryVariables
  > &
    (
      | { variables: TGetPatientDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetPatientDetailsQuery,
    TGetPatientDetailsQueryVariables
  >(GetPatientDetailsDocument, options);
}
export function useGetPatientDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetPatientDetailsQuery,
    TGetPatientDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetPatientDetailsQuery,
    TGetPatientDetailsQueryVariables
  >(GetPatientDetailsDocument, options);
}
// @ts-ignore
export function useGetPatientDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetPatientDetailsQuery,
    TGetPatientDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetPatientDetailsQuery,
  TGetPatientDetailsQueryVariables
>;
export function useGetPatientDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetPatientDetailsQuery,
        TGetPatientDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetPatientDetailsQuery | undefined,
  TGetPatientDetailsQueryVariables
>;
export function useGetPatientDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetPatientDetailsQuery,
        TGetPatientDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetPatientDetailsQuery,
    TGetPatientDetailsQueryVariables
  >(GetPatientDetailsDocument, options);
}
export type GetPatientDetailsQueryHookResult = ReturnType<
  typeof useGetPatientDetailsQuery
>;
export type GetPatientDetailsLazyQueryHookResult = ReturnType<
  typeof useGetPatientDetailsLazyQuery
>;
export type GetPatientDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetPatientDetailsSuspenseQuery
>;
export type GetPatientDetailsQueryResult = Apollo.QueryResult<
  TGetPatientDetailsQuery,
  TGetPatientDetailsQueryVariables
>;
export const UpdatePatientDetailsDocument = gql`
  mutation UpdatePatientDetails(
    $updatePatientId: MongoID!
    $updatePatientRecord: UpdateOnePatientInput!
  ) {
    updatePatient(
      filter: { _id: $updatePatientId }
      record: $updatePatientRecord
    ) {
      record {
        _id
        firstName
        lastName
        birthDate
        identificationType
        identificationNumber
        phone
        country
        email
        sex
        ethnicity
      }
    }
  }
`;
export type TUpdatePatientDetailsMutationFn = Apollo.MutationFunction<
  TUpdatePatientDetailsMutation,
  TUpdatePatientDetailsMutationVariables
>;

/**
 * __useUpdatePatientDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePatientDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientDetailsMutation, { data, loading, error }] = useUpdatePatientDetailsMutation({
 *   variables: {
 *      updatePatientId: // value for 'updatePatientId'
 *      updatePatientRecord: // value for 'updatePatientRecord'
 *   },
 * });
 */
export function useUpdatePatientDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TUpdatePatientDetailsMutation,
    TUpdatePatientDetailsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TUpdatePatientDetailsMutation,
    TUpdatePatientDetailsMutationVariables
  >(UpdatePatientDetailsDocument, options);
}
export type UpdatePatientDetailsMutationHookResult = ReturnType<
  typeof useUpdatePatientDetailsMutation
>;
export type UpdatePatientDetailsMutationResult =
  Apollo.MutationResult<TUpdatePatientDetailsMutation>;
export type UpdatePatientDetailsMutationOptions = Apollo.BaseMutationOptions<
  TUpdatePatientDetailsMutation,
  TUpdatePatientDetailsMutationVariables
>;
export const RemovePatientByIdDocument = gql`
  mutation removePatientById($removePatientId: MongoID!) {
    removePatientById(id: $removePatientId)
  }
`;
export type TRemovePatientByIdMutationFn = Apollo.MutationFunction<
  TRemovePatientByIdMutation,
  TRemovePatientByIdMutationVariables
>;

/**
 * __useRemovePatientByIdMutation__
 *
 * To run a mutation, you first call `useRemovePatientByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePatientByIdMutation, { data, loading, error }] = useRemovePatientByIdMutation({
 *   variables: {
 *      removePatientId: // value for 'removePatientId'
 *   },
 * });
 */
export function useRemovePatientByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TRemovePatientByIdMutation,
    TRemovePatientByIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TRemovePatientByIdMutation,
    TRemovePatientByIdMutationVariables
  >(RemovePatientByIdDocument, options);
}
export type RemovePatientByIdMutationHookResult = ReturnType<
  typeof useRemovePatientByIdMutation
>;
export type RemovePatientByIdMutationResult =
  Apollo.MutationResult<TRemovePatientByIdMutation>;
export type RemovePatientByIdMutationOptions = Apollo.BaseMutationOptions<
  TRemovePatientByIdMutation,
  TRemovePatientByIdMutationVariables
>;
export const ExamCountDocument = gql`
  query examCount($filter: FilterCountExamInput!) {
    examCount(filter: $filter)
  }
`;

/**
 * __useExamCountQuery__
 *
 * To run a query within a React component, call `useExamCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useExamCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExamCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExamCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    TExamCountQuery,
    TExamCountQueryVariables
  > &
    (
      | { variables: TExamCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TExamCountQuery, TExamCountQueryVariables>(
    ExamCountDocument,
    options,
  );
}
export function useExamCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TExamCountQuery,
    TExamCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TExamCountQuery, TExamCountQueryVariables>(
    ExamCountDocument,
    options,
  );
}
// @ts-ignore
export function useExamCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TExamCountQuery,
    TExamCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TExamCountQuery, TExamCountQueryVariables>;
export function useExamCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TExamCountQuery,
        TExamCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TExamCountQuery | undefined,
  TExamCountQueryVariables
>;
export function useExamCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TExamCountQuery,
        TExamCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TExamCountQuery, TExamCountQueryVariables>(
    ExamCountDocument,
    options,
  );
}
export type ExamCountQueryHookResult = ReturnType<typeof useExamCountQuery>;
export type ExamCountLazyQueryHookResult = ReturnType<
  typeof useExamCountLazyQuery
>;
export type ExamCountSuspenseQueryHookResult = ReturnType<
  typeof useExamCountSuspenseQuery
>;
export type ExamCountQueryResult = Apollo.QueryResult<
  TExamCountQuery,
  TExamCountQueryVariables
>;
export const PatientExamsDocument = gql`
  query PatientExams($examsFilter: FilterFindManyReducedExamInput!) {
    examsByPatient(filter: $examsFilter, sort: CREATED_AT_DESC) {
      _id
      examDate
      relevantFindingsCount
      technology
      priority
      user {
        firstName
        lastName
      }
      detectionsCount
      status
    }
  }
`;

/**
 * __usePatientExamsQuery__
 *
 * To run a query within a React component, call `usePatientExamsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientExamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientExamsQuery({
 *   variables: {
 *      examsFilter: // value for 'examsFilter'
 *   },
 * });
 */
export function usePatientExamsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TPatientExamsQuery,
    TPatientExamsQueryVariables
  > &
    (
      | { variables: TPatientExamsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TPatientExamsQuery, TPatientExamsQueryVariables>(
    PatientExamsDocument,
    options,
  );
}
export function usePatientExamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TPatientExamsQuery,
    TPatientExamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TPatientExamsQuery, TPatientExamsQueryVariables>(
    PatientExamsDocument,
    options,
  );
}
// @ts-ignore
export function usePatientExamsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TPatientExamsQuery,
    TPatientExamsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TPatientExamsQuery,
  TPatientExamsQueryVariables
>;
export function usePatientExamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TPatientExamsQuery,
        TPatientExamsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TPatientExamsQuery | undefined,
  TPatientExamsQueryVariables
>;
export function usePatientExamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TPatientExamsQuery,
        TPatientExamsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TPatientExamsQuery,
    TPatientExamsQueryVariables
  >(PatientExamsDocument, options);
}
export type PatientExamsQueryHookResult = ReturnType<
  typeof usePatientExamsQuery
>;
export type PatientExamsLazyQueryHookResult = ReturnType<
  typeof usePatientExamsLazyQuery
>;
export type PatientExamsSuspenseQueryHookResult = ReturnType<
  typeof usePatientExamsSuspenseQuery
>;
export type PatientExamsQueryResult = Apollo.QueryResult<
  TPatientExamsQuery,
  TPatientExamsQueryVariables
>;
export const GetClinicalIndicationDocument = gql`
  query GetClinicalIndication($examId: MongoID!) {
    exam(filter: { _id: $examId }) {
      clinicalIndication
      user {
        _id
      }
      physician {
        _id
      }
    }
  }
`;

/**
 * __useGetClinicalIndicationQuery__
 *
 * To run a query within a React component, call `useGetClinicalIndicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicalIndicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicalIndicationQuery({
 *   variables: {
 *      examId: // value for 'examId'
 *   },
 * });
 */
export function useGetClinicalIndicationQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetClinicalIndicationQuery,
    TGetClinicalIndicationQueryVariables
  > &
    (
      | { variables: TGetClinicalIndicationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetClinicalIndicationQuery,
    TGetClinicalIndicationQueryVariables
  >(GetClinicalIndicationDocument, options);
}
export function useGetClinicalIndicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetClinicalIndicationQuery,
    TGetClinicalIndicationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetClinicalIndicationQuery,
    TGetClinicalIndicationQueryVariables
  >(GetClinicalIndicationDocument, options);
}
// @ts-ignore
export function useGetClinicalIndicationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetClinicalIndicationQuery,
    TGetClinicalIndicationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetClinicalIndicationQuery,
  TGetClinicalIndicationQueryVariables
>;
export function useGetClinicalIndicationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetClinicalIndicationQuery,
        TGetClinicalIndicationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetClinicalIndicationQuery | undefined,
  TGetClinicalIndicationQueryVariables
>;
export function useGetClinicalIndicationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetClinicalIndicationQuery,
        TGetClinicalIndicationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetClinicalIndicationQuery,
    TGetClinicalIndicationQueryVariables
  >(GetClinicalIndicationDocument, options);
}
export type GetClinicalIndicationQueryHookResult = ReturnType<
  typeof useGetClinicalIndicationQuery
>;
export type GetClinicalIndicationLazyQueryHookResult = ReturnType<
  typeof useGetClinicalIndicationLazyQuery
>;
export type GetClinicalIndicationSuspenseQueryHookResult = ReturnType<
  typeof useGetClinicalIndicationSuspenseQuery
>;
export type GetClinicalIndicationQueryResult = Apollo.QueryResult<
  TGetClinicalIndicationQuery,
  TGetClinicalIndicationQueryVariables
>;
export const UpdateClinicalIndicationDocument = gql`
  mutation UpdateClinicalIndication(
    $examId: MongoID!
    $clinicalIndication: String!
  ) {
    updateExam(
      _id: $examId
      record: { clinicalIndication: $clinicalIndication }
    ) {
      record {
        _id
        clinicalIndication
      }
    }
  }
`;
export type TUpdateClinicalIndicationMutationFn = Apollo.MutationFunction<
  TUpdateClinicalIndicationMutation,
  TUpdateClinicalIndicationMutationVariables
>;

/**
 * __useUpdateClinicalIndicationMutation__
 *
 * To run a mutation, you first call `useUpdateClinicalIndicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicalIndicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicalIndicationMutation, { data, loading, error }] = useUpdateClinicalIndicationMutation({
 *   variables: {
 *      examId: // value for 'examId'
 *      clinicalIndication: // value for 'clinicalIndication'
 *   },
 * });
 */
export function useUpdateClinicalIndicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TUpdateClinicalIndicationMutation,
    TUpdateClinicalIndicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TUpdateClinicalIndicationMutation,
    TUpdateClinicalIndicationMutationVariables
  >(UpdateClinicalIndicationDocument, options);
}
export type UpdateClinicalIndicationMutationHookResult = ReturnType<
  typeof useUpdateClinicalIndicationMutation
>;
export type UpdateClinicalIndicationMutationResult =
  Apollo.MutationResult<TUpdateClinicalIndicationMutation>;
export type UpdateClinicalIndicationMutationOptions =
  Apollo.BaseMutationOptions<
    TUpdateClinicalIndicationMutation,
    TUpdateClinicalIndicationMutationVariables
  >;
export const GetMedicalNotesDocument = gql`
  query GetMedicalNotes($examId: MongoID!) {
    exam(filter: { _id: $examId }) {
      _id
      medicalNotes {
        _id
        user {
          firstName
          lastName
          _id
        }
        content
        creationDate
      }
    }
  }
`;

/**
 * __useGetMedicalNotesQuery__
 *
 * To run a query within a React component, call `useGetMedicalNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicalNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicalNotesQuery({
 *   variables: {
 *      examId: // value for 'examId'
 *   },
 * });
 */
export function useGetMedicalNotesQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetMedicalNotesQuery,
    TGetMedicalNotesQueryVariables
  > &
    (
      | { variables: TGetMedicalNotesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetMedicalNotesQuery, TGetMedicalNotesQueryVariables>(
    GetMedicalNotesDocument,
    options,
  );
}
export function useGetMedicalNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetMedicalNotesQuery,
    TGetMedicalNotesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetMedicalNotesQuery,
    TGetMedicalNotesQueryVariables
  >(GetMedicalNotesDocument, options);
}
// @ts-ignore
export function useGetMedicalNotesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetMedicalNotesQuery,
    TGetMedicalNotesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetMedicalNotesQuery,
  TGetMedicalNotesQueryVariables
>;
export function useGetMedicalNotesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetMedicalNotesQuery,
        TGetMedicalNotesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetMedicalNotesQuery | undefined,
  TGetMedicalNotesQueryVariables
>;
export function useGetMedicalNotesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetMedicalNotesQuery,
        TGetMedicalNotesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetMedicalNotesQuery,
    TGetMedicalNotesQueryVariables
  >(GetMedicalNotesDocument, options);
}
export type GetMedicalNotesQueryHookResult = ReturnType<
  typeof useGetMedicalNotesQuery
>;
export type GetMedicalNotesLazyQueryHookResult = ReturnType<
  typeof useGetMedicalNotesLazyQuery
>;
export type GetMedicalNotesSuspenseQueryHookResult = ReturnType<
  typeof useGetMedicalNotesSuspenseQuery
>;
export type GetMedicalNotesQueryResult = Apollo.QueryResult<
  TGetMedicalNotesQuery,
  TGetMedicalNotesQueryVariables
>;
export const CreateMedicalNoteDocument = gql`
  mutation CreateMedicalNote($examId: MongoID!, $content: String!) {
    createMedicalNote(examId: $examId, content: $content) {
      medicalNotes {
        _id
      }
    }
  }
`;
export type TCreateMedicalNoteMutationFn = Apollo.MutationFunction<
  TCreateMedicalNoteMutation,
  TCreateMedicalNoteMutationVariables
>;

/**
 * __useCreateMedicalNoteMutation__
 *
 * To run a mutation, you first call `useCreateMedicalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicalNoteMutation, { data, loading, error }] = useCreateMedicalNoteMutation({
 *   variables: {
 *      examId: // value for 'examId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateMedicalNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TCreateMedicalNoteMutation,
    TCreateMedicalNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TCreateMedicalNoteMutation,
    TCreateMedicalNoteMutationVariables
  >(CreateMedicalNoteDocument, options);
}
export type CreateMedicalNoteMutationHookResult = ReturnType<
  typeof useCreateMedicalNoteMutation
>;
export type CreateMedicalNoteMutationResult =
  Apollo.MutationResult<TCreateMedicalNoteMutation>;
export type CreateMedicalNoteMutationOptions = Apollo.BaseMutationOptions<
  TCreateMedicalNoteMutation,
  TCreateMedicalNoteMutationVariables
>;
export const UpdateMedicalNoteDocument = gql`
  mutation UpdateMedicalNote(
    $id: MongoID!
    $examId: MongoID!
    $content: String!
  ) {
    updateMedicalNote(id: $id, examId: $examId, content: $content) {
      medicalNotes {
        _id
      }
    }
  }
`;
export type TUpdateMedicalNoteMutationFn = Apollo.MutationFunction<
  TUpdateMedicalNoteMutation,
  TUpdateMedicalNoteMutationVariables
>;

/**
 * __useUpdateMedicalNoteMutation__
 *
 * To run a mutation, you first call `useUpdateMedicalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicalNoteMutation, { data, loading, error }] = useUpdateMedicalNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      examId: // value for 'examId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateMedicalNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TUpdateMedicalNoteMutation,
    TUpdateMedicalNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TUpdateMedicalNoteMutation,
    TUpdateMedicalNoteMutationVariables
  >(UpdateMedicalNoteDocument, options);
}
export type UpdateMedicalNoteMutationHookResult = ReturnType<
  typeof useUpdateMedicalNoteMutation
>;
export type UpdateMedicalNoteMutationResult =
  Apollo.MutationResult<TUpdateMedicalNoteMutation>;
export type UpdateMedicalNoteMutationOptions = Apollo.BaseMutationOptions<
  TUpdateMedicalNoteMutation,
  TUpdateMedicalNoteMutationVariables
>;
export const DeleteMedicalNoteDocument = gql`
  mutation DeleteMedicalNote($id: MongoID!, $examId: MongoID!) {
    deleteMedicalNote(id: $id, examId: $examId) {
      medicalNotes {
        _id
      }
    }
  }
`;
export type TDeleteMedicalNoteMutationFn = Apollo.MutationFunction<
  TDeleteMedicalNoteMutation,
  TDeleteMedicalNoteMutationVariables
>;

/**
 * __useDeleteMedicalNoteMutation__
 *
 * To run a mutation, you first call `useDeleteMedicalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMedicalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMedicalNoteMutation, { data, loading, error }] = useDeleteMedicalNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      examId: // value for 'examId'
 *   },
 * });
 */
export function useDeleteMedicalNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TDeleteMedicalNoteMutation,
    TDeleteMedicalNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TDeleteMedicalNoteMutation,
    TDeleteMedicalNoteMutationVariables
  >(DeleteMedicalNoteDocument, options);
}
export type DeleteMedicalNoteMutationHookResult = ReturnType<
  typeof useDeleteMedicalNoteMutation
>;
export type DeleteMedicalNoteMutationResult =
  Apollo.MutationResult<TDeleteMedicalNoteMutation>;
export type DeleteMedicalNoteMutationOptions = Apollo.BaseMutationOptions<
  TDeleteMedicalNoteMutation,
  TDeleteMedicalNoteMutationVariables
>;
export const GetPatientExamDetailsDocument = gql`
  query GetPatientExamDetails(
    $examId: MongoID!
    $technology: EnumExamTechnology
  ) {
    exam(filter: { _id: $examId, technology: $technology }) {
      _id
      examDate
      findings {
        _id
        highlight
        targets {
          _id
          code
          certainty
        }
        index
        timeStamp
        location
        frame
        thumbnail
        relevant
        userLabel
      }
      detectionResults {
        _id
        origFilename
        origShape
        names
        detections {
          classId
          class
          confidence
          box {
            left
            top
            right
            bottom
          }
          smartCystHistologicalResult
          smartPancreasHistologicalResult
          anoscopyGeniusHistologicalResult
          position
        }
      }
      histologicalResult
      priority
      user {
        _id
        firstName
        lastName
        firebaseId
        institution {
          _id
        }
      }
      physician {
        _id
        firstName
        lastName
      }
      technology
      device
      media {
        fullVideo
        highlights
        frames
      }
      clinicalIndication
      status
      createdAt
      medicalNotes {
        _id
        user {
          firstName
          lastName
          _id
        }
        content
        creationDate
      }
      laboratoryResult {
        glucoseLevel
        ceaLevel
      }
    }
  }
`;

/**
 * __useGetPatientExamDetailsQuery__
 *
 * To run a query within a React component, call `useGetPatientExamDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientExamDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientExamDetailsQuery({
 *   variables: {
 *      examId: // value for 'examId'
 *      technology: // value for 'technology'
 *   },
 * });
 */
export function useGetPatientExamDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetPatientExamDetailsQuery,
    TGetPatientExamDetailsQueryVariables
  > &
    (
      | { variables: TGetPatientExamDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetPatientExamDetailsQuery,
    TGetPatientExamDetailsQueryVariables
  >(GetPatientExamDetailsDocument, options);
}
export function useGetPatientExamDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetPatientExamDetailsQuery,
    TGetPatientExamDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetPatientExamDetailsQuery,
    TGetPatientExamDetailsQueryVariables
  >(GetPatientExamDetailsDocument, options);
}
// @ts-ignore
export function useGetPatientExamDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetPatientExamDetailsQuery,
    TGetPatientExamDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetPatientExamDetailsQuery,
  TGetPatientExamDetailsQueryVariables
>;
export function useGetPatientExamDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetPatientExamDetailsQuery,
        TGetPatientExamDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetPatientExamDetailsQuery | undefined,
  TGetPatientExamDetailsQueryVariables
>;
export function useGetPatientExamDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetPatientExamDetailsQuery,
        TGetPatientExamDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetPatientExamDetailsQuery,
    TGetPatientExamDetailsQueryVariables
  >(GetPatientExamDetailsDocument, options);
}
export type GetPatientExamDetailsQueryHookResult = ReturnType<
  typeof useGetPatientExamDetailsQuery
>;
export type GetPatientExamDetailsLazyQueryHookResult = ReturnType<
  typeof useGetPatientExamDetailsLazyQuery
>;
export type GetPatientExamDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetPatientExamDetailsSuspenseQuery
>;
export type GetPatientExamDetailsQueryResult = Apollo.QueryResult<
  TGetPatientExamDetailsQuery,
  TGetPatientExamDetailsQueryVariables
>;
export const GetPatientExamEditDetailsDocument = gql`
  query GetPatientExamEditDetails(
    $examId: MongoID!
    $technology: EnumExamTechnology
  ) {
    exam(filter: { _id: $examId, technology: $technology }) {
      _id
      examDate
      histologicalResult
      clinicalIndication
      priority
      status
      user {
        _id
        firstName
        lastName
        firebaseId
        institution {
          _id
        }
      }
      physician {
        _id
        firstName
        lastName
      }
      laboratoryResult {
        glucoseLevel
        ceaLevel
      }
    }
  }
`;

/**
 * __useGetPatientExamEditDetailsQuery__
 *
 * To run a query within a React component, call `useGetPatientExamEditDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientExamEditDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientExamEditDetailsQuery({
 *   variables: {
 *      examId: // value for 'examId'
 *      technology: // value for 'technology'
 *   },
 * });
 */
export function useGetPatientExamEditDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetPatientExamEditDetailsQuery,
    TGetPatientExamEditDetailsQueryVariables
  > &
    (
      | { variables: TGetPatientExamEditDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetPatientExamEditDetailsQuery,
    TGetPatientExamEditDetailsQueryVariables
  >(GetPatientExamEditDetailsDocument, options);
}
export function useGetPatientExamEditDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetPatientExamEditDetailsQuery,
    TGetPatientExamEditDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetPatientExamEditDetailsQuery,
    TGetPatientExamEditDetailsQueryVariables
  >(GetPatientExamEditDetailsDocument, options);
}
// @ts-ignore
export function useGetPatientExamEditDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetPatientExamEditDetailsQuery,
    TGetPatientExamEditDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetPatientExamEditDetailsQuery,
  TGetPatientExamEditDetailsQueryVariables
>;
export function useGetPatientExamEditDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetPatientExamEditDetailsQuery,
        TGetPatientExamEditDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetPatientExamEditDetailsQuery | undefined,
  TGetPatientExamEditDetailsQueryVariables
>;
export function useGetPatientExamEditDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetPatientExamEditDetailsQuery,
        TGetPatientExamEditDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetPatientExamEditDetailsQuery,
    TGetPatientExamEditDetailsQueryVariables
  >(GetPatientExamEditDetailsDocument, options);
}
export type GetPatientExamEditDetailsQueryHookResult = ReturnType<
  typeof useGetPatientExamEditDetailsQuery
>;
export type GetPatientExamEditDetailsLazyQueryHookResult = ReturnType<
  typeof useGetPatientExamEditDetailsLazyQuery
>;
export type GetPatientExamEditDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetPatientExamEditDetailsSuspenseQuery
>;
export type GetPatientExamEditDetailsQueryResult = Apollo.QueryResult<
  TGetPatientExamEditDetailsQuery,
  TGetPatientExamEditDetailsQueryVariables
>;
export const UpdateExamDetectionHistologicalResultDocument = gql`
  mutation UpdateExamDetectionHistologicalResult(
    $examId: MongoID!
    $detectionResultId: MongoID!
    $histologicalResult: String
    $position: Int!
    $technology: EnumExamTechnology!
  ) {
    updateExamDetectionHistologicalResult(
      _id: $examId
      detectionResultId: $detectionResultId
      histologicalResult: $histologicalResult
      position: $position
      technology: $technology
    ) {
      _id
    }
  }
`;
export type TUpdateExamDetectionHistologicalResultMutationFn =
  Apollo.MutationFunction<
    TUpdateExamDetectionHistologicalResultMutation,
    TUpdateExamDetectionHistologicalResultMutationVariables
  >;

/**
 * __useUpdateExamDetectionHistologicalResultMutation__
 *
 * To run a mutation, you first call `useUpdateExamDetectionHistologicalResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamDetectionHistologicalResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamDetectionHistologicalResultMutation, { data, loading, error }] = useUpdateExamDetectionHistologicalResultMutation({
 *   variables: {
 *      examId: // value for 'examId'
 *      detectionResultId: // value for 'detectionResultId'
 *      histologicalResult: // value for 'histologicalResult'
 *      position: // value for 'position'
 *      technology: // value for 'technology'
 *   },
 * });
 */
export function useUpdateExamDetectionHistologicalResultMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TUpdateExamDetectionHistologicalResultMutation,
    TUpdateExamDetectionHistologicalResultMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TUpdateExamDetectionHistologicalResultMutation,
    TUpdateExamDetectionHistologicalResultMutationVariables
  >(UpdateExamDetectionHistologicalResultDocument, options);
}
export type UpdateExamDetectionHistologicalResultMutationHookResult =
  ReturnType<typeof useUpdateExamDetectionHistologicalResultMutation>;
export type UpdateExamDetectionHistologicalResultMutationResult =
  Apollo.MutationResult<TUpdateExamDetectionHistologicalResultMutation>;
export type UpdateExamDetectionHistologicalResultMutationOptions =
  Apollo.BaseMutationOptions<
    TUpdateExamDetectionHistologicalResultMutation,
    TUpdateExamDetectionHistologicalResultMutationVariables
  >;
export const GetPatientListConnectionDocument = gql`
  query GetPatientListConnection(
    $after: String
    $before: String
    $sort: String
    $first: Int
    $last: Int
    $patientId: String
  ) {
    patientListConnection(
      after: $after
      before: $before
      sort: $sort
      first: $first
      last: $last
      patientId: $patientId
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          avatar
          firstName
          lastName
          _id
          identificationNumber
          identificationType
        }
      }
    }
  }
`;

/**
 * __useGetPatientListConnectionQuery__
 *
 * To run a query within a React component, call `useGetPatientListConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientListConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientListConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useGetPatientListConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TGetPatientListConnectionQuery,
    TGetPatientListConnectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetPatientListConnectionQuery,
    TGetPatientListConnectionQueryVariables
  >(GetPatientListConnectionDocument, options);
}
export function useGetPatientListConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetPatientListConnectionQuery,
    TGetPatientListConnectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetPatientListConnectionQuery,
    TGetPatientListConnectionQueryVariables
  >(GetPatientListConnectionDocument, options);
}
// @ts-ignore
export function useGetPatientListConnectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetPatientListConnectionQuery,
    TGetPatientListConnectionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetPatientListConnectionQuery,
  TGetPatientListConnectionQueryVariables
>;
export function useGetPatientListConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetPatientListConnectionQuery,
        TGetPatientListConnectionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetPatientListConnectionQuery | undefined,
  TGetPatientListConnectionQueryVariables
>;
export function useGetPatientListConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetPatientListConnectionQuery,
        TGetPatientListConnectionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetPatientListConnectionQuery,
    TGetPatientListConnectionQueryVariables
  >(GetPatientListConnectionDocument, options);
}
export type GetPatientListConnectionQueryHookResult = ReturnType<
  typeof useGetPatientListConnectionQuery
>;
export type GetPatientListConnectionLazyQueryHookResult = ReturnType<
  typeof useGetPatientListConnectionLazyQuery
>;
export type GetPatientListConnectionSuspenseQueryHookResult = ReturnType<
  typeof useGetPatientListConnectionSuspenseQuery
>;
export type GetPatientListConnectionQueryResult = Apollo.QueryResult<
  TGetPatientListConnectionQuery,
  TGetPatientListConnectionQueryVariables
>;
export const GetExamsByUserConnectionDocument = gql`
  query GetExamsByUserConnection(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $nameSearch: String
    $technology: EnumExamTechnology
    $afterDate: Date
    $beforeDate: Date
  ) {
    examsByUserConnection(
      after: $after
      before: $before
      first: $first
      last: $last
      nameSearch: $nameSearch
      technology: $technology
      afterDate: $afterDate
      beforeDate: $beforeDate
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          _id
          user {
            fullName
          }
          patient {
            _id
            firstName
            lastName
            fullName
            identificationNumber
            identificationType
          }
          examDate
          priority
          relevantFindingsCount
          status
          detectionsCount
          histologicalResult
        }
      }
    }
  }
`;

/**
 * __useGetExamsByUserConnectionQuery__
 *
 * To run a query within a React component, call `useGetExamsByUserConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamsByUserConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamsByUserConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      nameSearch: // value for 'nameSearch'
 *      technology: // value for 'technology'
 *      afterDate: // value for 'afterDate'
 *      beforeDate: // value for 'beforeDate'
 *   },
 * });
 */
export function useGetExamsByUserConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TGetExamsByUserConnectionQuery,
    TGetExamsByUserConnectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetExamsByUserConnectionQuery,
    TGetExamsByUserConnectionQueryVariables
  >(GetExamsByUserConnectionDocument, options);
}
export function useGetExamsByUserConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetExamsByUserConnectionQuery,
    TGetExamsByUserConnectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetExamsByUserConnectionQuery,
    TGetExamsByUserConnectionQueryVariables
  >(GetExamsByUserConnectionDocument, options);
}
// @ts-ignore
export function useGetExamsByUserConnectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetExamsByUserConnectionQuery,
    TGetExamsByUserConnectionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetExamsByUserConnectionQuery,
  TGetExamsByUserConnectionQueryVariables
>;
export function useGetExamsByUserConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetExamsByUserConnectionQuery,
        TGetExamsByUserConnectionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetExamsByUserConnectionQuery | undefined,
  TGetExamsByUserConnectionQueryVariables
>;
export function useGetExamsByUserConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetExamsByUserConnectionQuery,
        TGetExamsByUserConnectionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetExamsByUserConnectionQuery,
    TGetExamsByUserConnectionQueryVariables
  >(GetExamsByUserConnectionDocument, options);
}
export type GetExamsByUserConnectionQueryHookResult = ReturnType<
  typeof useGetExamsByUserConnectionQuery
>;
export type GetExamsByUserConnectionLazyQueryHookResult = ReturnType<
  typeof useGetExamsByUserConnectionLazyQuery
>;
export type GetExamsByUserConnectionSuspenseQueryHookResult = ReturnType<
  typeof useGetExamsByUserConnectionSuspenseQuery
>;
export type GetExamsByUserConnectionQueryResult = Apollo.QueryResult<
  TGetExamsByUserConnectionQuery,
  TGetExamsByUserConnectionQueryVariables
>;
export const GetExamValidationDataDocument = gql`
  query GetExamValidationData(
    $examId: MongoID!
    $technology: EnumExamTechnology
  ) {
    exam(filter: { _id: $examId, technology: $technology }) {
      _id
      user {
        _id
        firebaseId
        institution {
          _id
        }
      }
      patient {
        _id
      }
      physician {
        _id
      }
      technology
      findings {
        _id
        targets {
          _id
          code
          certainty
        }
        index
        timeStamp
        location
        frame
        thumbnail
        relevant
        userLabel
      }
      filters
    }
  }
`;

/**
 * __useGetExamValidationDataQuery__
 *
 * To run a query within a React component, call `useGetExamValidationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamValidationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamValidationDataQuery({
 *   variables: {
 *      examId: // value for 'examId'
 *      technology: // value for 'technology'
 *   },
 * });
 */
export function useGetExamValidationDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetExamValidationDataQuery,
    TGetExamValidationDataQueryVariables
  > &
    (
      | { variables: TGetExamValidationDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TGetExamValidationDataQuery,
    TGetExamValidationDataQueryVariables
  >(GetExamValidationDataDocument, options);
}
export function useGetExamValidationDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetExamValidationDataQuery,
    TGetExamValidationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetExamValidationDataQuery,
    TGetExamValidationDataQueryVariables
  >(GetExamValidationDataDocument, options);
}
// @ts-ignore
export function useGetExamValidationDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetExamValidationDataQuery,
    TGetExamValidationDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetExamValidationDataQuery,
  TGetExamValidationDataQueryVariables
>;
export function useGetExamValidationDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetExamValidationDataQuery,
        TGetExamValidationDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetExamValidationDataQuery | undefined,
  TGetExamValidationDataQueryVariables
>;
export function useGetExamValidationDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetExamValidationDataQuery,
        TGetExamValidationDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetExamValidationDataQuery,
    TGetExamValidationDataQueryVariables
  >(GetExamValidationDataDocument, options);
}
export type GetExamValidationDataQueryHookResult = ReturnType<
  typeof useGetExamValidationDataQuery
>;
export type GetExamValidationDataLazyQueryHookResult = ReturnType<
  typeof useGetExamValidationDataLazyQuery
>;
export type GetExamValidationDataSuspenseQueryHookResult = ReturnType<
  typeof useGetExamValidationDataSuspenseQuery
>;
export type GetExamValidationDataQueryResult = Apollo.QueryResult<
  TGetExamValidationDataQuery,
  TGetExamValidationDataQueryVariables
>;
export const ValidateExamDocument = gql`
  mutation ValidateExam(
    $validateExamId: MongoID!
    $updatedFindings: [InputUpdatedFinding!]!
    $filters: JSON
  ) {
    validateExam(
      _id: $validateExamId
      updatedFindings: $updatedFindings
      filters: $filters
    ) {
      _id
      user {
        _id
        firebaseId
        institution {
          _id
        }
      }
      patient {
        _id
      }
      physician {
        _id
      }
      technology
      filters
    }
  }
`;
export type TValidateExamMutationFn = Apollo.MutationFunction<
  TValidateExamMutation,
  TValidateExamMutationVariables
>;

/**
 * __useValidateExamMutation__
 *
 * To run a mutation, you first call `useValidateExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateExamMutation, { data, loading, error }] = useValidateExamMutation({
 *   variables: {
 *      validateExamId: // value for 'validateExamId'
 *      updatedFindings: // value for 'updatedFindings'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useValidateExamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TValidateExamMutation,
    TValidateExamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TValidateExamMutation,
    TValidateExamMutationVariables
  >(ValidateExamDocument, options);
}
export type ValidateExamMutationHookResult = ReturnType<
  typeof useValidateExamMutation
>;
export type ValidateExamMutationResult =
  Apollo.MutationResult<TValidateExamMutation>;
export type ValidateExamMutationOptions = Apollo.BaseMutationOptions<
  TValidateExamMutation,
  TValidateExamMutationVariables
>;
export const PatientSearchDocument = gql`
  query PatientSearch($search: String!) {
    patientsSearch(search: $search) {
      patients {
        _id
        fullIdentification
      }
      hasMoreResults
    }
  }
`;

/**
 * __usePatientSearchQuery__
 *
 * To run a query within a React component, call `usePatientSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePatientSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    TPatientSearchQuery,
    TPatientSearchQueryVariables
  > &
    (
      | { variables: TPatientSearchQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TPatientSearchQuery, TPatientSearchQueryVariables>(
    PatientSearchDocument,
    options,
  );
}
export function usePatientSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TPatientSearchQuery,
    TPatientSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TPatientSearchQuery, TPatientSearchQueryVariables>(
    PatientSearchDocument,
    options,
  );
}
// @ts-ignore
export function usePatientSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TPatientSearchQuery,
    TPatientSearchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TPatientSearchQuery,
  TPatientSearchQueryVariables
>;
export function usePatientSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TPatientSearchQuery,
        TPatientSearchQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TPatientSearchQuery | undefined,
  TPatientSearchQueryVariables
>;
export function usePatientSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TPatientSearchQuery,
        TPatientSearchQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TPatientSearchQuery,
    TPatientSearchQueryVariables
  >(PatientSearchDocument, options);
}
export type PatientSearchQueryHookResult = ReturnType<
  typeof usePatientSearchQuery
>;
export type PatientSearchLazyQueryHookResult = ReturnType<
  typeof usePatientSearchLazyQuery
>;
export type PatientSearchSuspenseQueryHookResult = ReturnType<
  typeof usePatientSearchSuspenseQuery
>;
export type PatientSearchQueryResult = Apollo.QueryResult<
  TPatientSearchQuery,
  TPatientSearchQueryVariables
>;
export const GetUserSessionDocument = gql`
  query GetUserSession($filter: FilterFindOneUserInput!) {
    user(filter: $filter) {
      _id
      firebaseId
      email
      firstName
      lastName
      avatar
      timezone
      institution {
        _id
        name
        dataAccessScope
      }
    }
  }
`;

/**
 * __useGetUserSessionQuery__
 *
 * To run a query within a React component, call `useGetUserSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSessionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUserSessionQuery(
  baseOptions: Apollo.QueryHookOptions<
    TGetUserSessionQuery,
    TGetUserSessionQueryVariables
  > &
    (
      | { variables: TGetUserSessionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetUserSessionQuery, TGetUserSessionQueryVariables>(
    GetUserSessionDocument,
    options,
  );
}
export function useGetUserSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TGetUserSessionQuery,
    TGetUserSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TGetUserSessionQuery,
    TGetUserSessionQueryVariables
  >(GetUserSessionDocument, options);
}
// @ts-ignore
export function useGetUserSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TGetUserSessionQuery,
    TGetUserSessionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TGetUserSessionQuery,
  TGetUserSessionQueryVariables
>;
export function useGetUserSessionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetUserSessionQuery,
        TGetUserSessionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TGetUserSessionQuery | undefined,
  TGetUserSessionQueryVariables
>;
export function useGetUserSessionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TGetUserSessionQuery,
        TGetUserSessionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TGetUserSessionQuery,
    TGetUserSessionQueryVariables
  >(GetUserSessionDocument, options);
}
export type GetUserSessionQueryHookResult = ReturnType<
  typeof useGetUserSessionQuery
>;
export type GetUserSessionLazyQueryHookResult = ReturnType<
  typeof useGetUserSessionLazyQuery
>;
export type GetUserSessionSuspenseQueryHookResult = ReturnType<
  typeof useGetUserSessionSuspenseQuery
>;
export type GetUserSessionQueryResult = Apollo.QueryResult<
  TGetUserSessionQuery,
  TGetUserSessionQueryVariables
>;
